function snizeCustomFilterOptionsOrder() {

/*
MODIFICATION IS PROVIDED BY THE SEARCHANISE TEAM. WITH ANY QUESTIONS, CONTACT US AT feedback@searchanise.io

The modification allows setting the order of the Modell filter options by coping and pasting the order-value pairs from a CSV file.

You can update the filter options order by replacing the value of the filterImport variable. 

Please pay attention to the formatting:
1. Please note that it should not include column names or any additional columns.
2. The order column should always come first.
3. Be sure not to make any manual changes to the spacings or lines.
4. Please keep opening and closing backticks (``) on separate lines.

Here is an example of the expected format: 

let filterImport = 
`
1	iPhone 17
2	iPhone 17 Pro
3	iPhone 17 Pro Max
4	iPhone 17e
5	iPhone Air
`;

After making the changes, be sure to check if the search results page loads normally as errors in the modification may lead to the widget stop showing results. 

If you need to quickly disable the modification, you can do it by changing the isEnabled variable value from true to false: 
let isEnabled = false;

*/

// SETTINGS START

let filterImport = 
`
1	Acer Iconia Duo S14
2	Acer Iconia Duo S12
3	Acer Iconia Duo D12
4	Acer Iconia A11 (A11-21M)
5	Acer Iconia A11 (A11-11)
6	Acer Iconia V12 (V12-11M)
7	Acer Iconia V11 (V11-21M)
8	Acer Iconia V11 (V11-11)
9	Acer Iconia Tab A10
10	Acer Iconia Tab M10
11	Acer Iconia Tab P11
12	Acer Iconia Tab P10
13	Acer Iconia Tab 10 A3-A40
14	Acer Iconia Tab 10 A3-A30
15	Acer Iconia Tab A3-A20
16	Acer Iconia Tab 8 A1-840FHD
17	Acer Iconia X12
18	Acer Iconia Talk S
19	Acer Iconia One 8 B1-820
20	Acer Iconia One 7 B1-730
21	Acer Iconia B1-720
22	Acer Iconia A1-830
23	Acer Predator 8
24	AGM H6 / H6 Lite
25	AGM H6
26	AGM H6 Lite
27	Alcatel 1c (2019)
28	Alcatel 3X (2020)
29	ALLDOCUBE iPlay 80 mini Ultra
30	ALLDOCUBE iPlay 80 mini Pro
31	ALLDOCUBE iPlay 70 Pad
32	ALLDOCUBE iPlay 70 Pad Pro
33	ALLDOCUBE Ultra Pad
34	Amazfit Balance 3
35	Amazfit Balance Ultra
36	Amazfit T-Rex 3 Pro (44mm)
37	Amazfit T-Rex 3 Pro (48mm)
38	Amazon Fire Phone
39	Amazon Fire 7 (2022)
40	Amazon Fire 7 (2017/2019)
41	Amazon Fire 7 (2017)
42	Amazon Fire 7 (2019)
43	Amazon Fire HD 8 (2024)
44	Amazon Fire HD 8 Kids (2024)
45	Amazon Fire HD8 Kids Pro 2024
46	Amazon Fire HD 8 (2022)
47	Amazon FireHD 8 Kids Pro 2022
48	Amazon Fire HD 8 Plus (2022)
49	Amazon Fire HD 8/8 Plus 2020
50	Amazon Fire HD 8 (2020)
51	Amazon Fire HD 8 Plus (2020)
52	Amazon Fire HD 10 (2023)
53	Amazon Fire HD 10 Kids (2023)
54	Amazon FireHD10 Kids Pro 2023
55	Amazon Fire HD 10 (2021)
56	Amazon Fire HD 10 Plus (2021)
57	Amazon Fire HD 10 (2017/2019)
58	Amazon Fire HD 10 (2017)
59	Amazon Fire HD 10 (2019)
60	Amazon Fire Max 11
61	Amazon Kindle (2024)
62	Amazon Kindle (2022)
63	Amazon Kindle (2019)
64	Amazon Kindle (2016)
65	Amazon Kindle Paperwhite 2024
66	Amazon Kindle Paperwhite 2021
67	Amazon Kindle Paperwhite 4
68	Amazon Kindle Paperwhite 1-3
69	Amazon Kindle Paperwhite 3
70	Amazon Kindle Paperwhite 2
71	Amazon Kindle Paperwhite 1
72	Amazon Kindle Colorsoft 2025
73	Amazon Kindle Scribe (2025)
74	Kindle Scribe Colorsoft(2025)
75	Amazon Kindle Scribe (2022)
76	Amazon Kindle Oasis (2019)
77	Amazon Kindle Oasis (2017)
78	Amazon Kindle Oasis (2016)
79	Amazon Kindle Voyage
80	iPhone 17 Pro/18 Pro
81	iPhone 17 Pro Max/18 Pro Max
82	iPhone 18 Pro
83	iPhone 18 Pro Max
84	iPhone Ultra
85	iPhone 17
86	iPhone 17 Pro
87	iPhone 17 Pro Max
88	iPhone 17e
89	iPhone Air
90	iPhone 16
91	iPhone 16 Plus
92	iPhone 16 Pro
93	iPhone 16 Pro Max
94	iPhone 16e
95	iPhone 15
96	iPhone 15 Plus
97	iPhone 15 Pro
98	iPhone 15 Pro Max
99	iPhone 14
100	iPhone 14 Plus
101	iPhone 14 Pro
102	iPhone 14 Pro Max
103	iPhone 13 / 13 Pro
104	iPhone 13
105	iPhone 13 mini
106	iPhone 13 Pro
107	iPhone 13 Pro
108	iPhone 13 Pro Max
109	iPhone 12 / 12 Pro
110	iPhone 12
111	iPhone 12 mini
112	iPhone 12 Pro
113	iPhone 12 Pro Max
114	iPhone 11
115	iPhone 11 Pro
116	iPhone 11 Pro Max
117	iPhone X / iPhone XS
118	iPhone X
119	iPhone XS
120	iPhone XS Max
121	iPhone XR
122	iPhone 7 / iPhone 8
123	iPhone 8
124	iPhone 8
125	iPhone 8 Plus
126	iPhone 7
127	iPhone 7
128	iPhone 7 Plus
129	iPhone 7 Plus / iPhone 8 Plus
130	iPhone 6s / iPhone 6
131	iPhone 6
132	iPhone 6s
133	iPhone 6s Plus / 6 Plus
134	iPhone 6 Plus
135	iPhone 6s Plus
136	iPhone 5s / 5 / SE (2016)
137	iPhone 5
138	iPhone 5s
139	iPhone 5c
140	iPhone 4S / iPhone 4
141	iPhone 4S
142	iPhone 4
143	iPhone SE (2020/2022)
144	iPhone 7 / 8 / SE (2020/2022)
145	iPhone SE (2022)
146	iPhone SE (2022)
147	iPhone SE (2020)
148	iPhone SE (2020)
149	iPhone SE (2016)
150	iPad 10/11/12 (2022/25/26)
151	iPad 10 (2022)
152	iPad 11 (2025)
153	iPad 12 (2026)
154	iPad 7 / 8 / 9 (2019 - 2021)
155	iPad 7 / iPad Air 3 (2019)
156	iPad 9 (2021)
157	iPad 8 (2020)
158	iPad 7 (2019)
159	iPad 7 (2019)
160	iPad 5/6, Air 1/2, Pro 9.7
161	iPad 6 (2018)
162	iPad 5 (2017)
163	iPad 2 / 3 / 4 (2011 - 2012)
164	iPad 4 (2012)
165	iPad 3 (2012)
166	iPad 2 (2011)
167	iPad Pro 11 (2024/2025)
168	iPad Pro 11 (2024)
169	iPad Pro 11 (2025)
170	iPad Pro 13 (2024/2025)
171	iPad Pro 13 (2024)
172	iPad Pro 13 (2025)
173	iPad Pro 12.9 (2020-2022)
174	iPad Pro 12.9 (2018-2022)
175	iPad Pro 12.9 (2022)
176	iPad Pro 12.9 (2022)
177	iPad Pro 12.9 (2021)
178	iPad Pro 12.9 (2021)
179	iPad Pro 12.9 (2021)
180	iPad Pro 12.9 (2020)
181	iPad Pro 12.9 (2018 / 2020)
182	iPad Pro 12.9 (2020)
183	iPad Pro 12.9 (2020)
184	iPad Pro 12.9 (2018)
185	iPad Pro 12.9 (2018)
186	iPad Pro 12.9 (2015 / 2017)
187	iPad Pro 12.9 (2017)
188	iPad Pro 12.9 (2015)
189	iPad Pro 11 (2018-2022)
190	iPad Pro 11 (2020-2022)
191	iPad Pro 11 (2022)
192	iPad Pro 11 (2022)
193	iPad Pro 11 (2021)
194	iPad Pro 11 (2021)
195	iPad Pro 11 (2020)
196	iPad Pro 11 (2020)
197	iPad Pro 11 (2018)
198	iPad Pro 10.5 (2017)
199	iPad Pro 10.5 (2017)
200	iPad Pro 9.7 (2016)
201	iPad Air 11 (2024/25/26)
202	iPad Air 11 (2024)
203	iPad Air 11 (2025)
204	iPad Air 11 (2026)
205	iPad Air 13 (2024/25/26)
206	iPad Air 13 (2024)
207	iPad Air 13 (2025)
208	iPad Air 13 (2026)
209	iPad Air 4 / 5 (2020 / 2022)
210	iPad Air 5 (2022)
211	iPad Air 4 (2020)
212	iPad Air 3 / iPad Pro 10.5
213	iPad Air 3 (2019)
214	iPad Air 3 (2019)
215	iPad Air 2 (2014)
216	iPad Air 1 (2013)
217	iPad mini 6 / 7 (2021 / 2024)
218	iPad mini 6 (2021)
219	iPad mini 7 (2024)
220	iPad mini 4 / 5 (2015 / 2019)
221	iPad mini 5 (2019)
222	iPad mini 5 (2019)
223	iPad mini 4 (2015)
224	iPad mini 4 (2015)
225	iPad mini 2/3/4/5 (2014-2019)
226	iPad mini 1/2/3 (2012-2014)
227	iPad mini 3 (2014)
228	iPad mini 3 (2014)
229	iPad mini 2 (2013)
230	iPad mini 2 (2013)
231	iPad mini 1 (2012)
232	iPad mini 1 (2012)
233	Apple Watch 12 (42mm)
234	Apple Watch 12 (46mm)
235	Apple Watch 11 (42mm)
236	Apple Watch 11 (46mm)
237	Apple Watch 10 (42mm)
238	Apple Watch 10 (46mm)
239	Apple Watch 9 (41mm)
240	Apple Watch 9 (45mm)
241	Apple Watch 8 (41mm)
242	Apple Watch 8 (45mm)
243	Apple Watch 7 (41mm)
244	Apple Watch 7 (45mm)
245	Apple Watch 6 (40mm)
246	Apple Watch 6 (44mm)
247	Apple Watch 5 (40mm)
248	Apple Watch 5 (44mm)
249	Apple Watch 4 (40mm)
250	Apple Watch 4 (44mm)
251	Apple Watch 3 (38mm)
252	Apple Watch 3 (42mm)
253	Apple Watch 2 (38mm)
254	Apple Watch 2 (42mm)
255	Apple Watch 1 (38mm)
256	Apple Watch 1 (42mm)
257	Apple Watch Ultra 4 (49mm)
258	Apple Watch Ultra 3 (49mm)
259	Apple Watch Ultra 2 (49mm)
260	Apple Watch Ultra 1 (49mm)
261	Apple Watch SE 3 (40mm)
262	Apple Watch SE 3 (44mm)
263	Apple Watch SE 2 (40mm)
264	Apple Watch SE 2 (44mm)
265	Apple Watch SE 1 (40mm)
266	Apple Watch SE 1 (44mm)
267	AirPods 4
268	AirPods 3
269	AirPods (1 / 2)
270	AirPods 2
271	AirPods 1
272	AirPods Pro 3
273	AirPods Pro (1 / 2)
274	AirPods Pro 2
275	AirPods Pro 1
276	Artfone C3
277	Artfone C1/C1+
278	Artfone C1
279	Artfone C1+
280	Artfone CS182
281	Asus Zenfone 12 Ultra
282	Asus Zenfone 11 Ultra
283	Asus Zenfone 10
284	Asus Zenfone 9
285	Asus Zenfone 8
286	Asus Zenfone 8 Flip
287	Asus Zenfone 7 / Zenfone 7Pro
288	Asus Zenfone 7
289	Asus Zenfone 7 Pro
290	Asus Zenfone 6 (2019)
291	Asus Zenfone 3 (ZE552KL)
292	Asus ROG Phone 9 / 9 Pro
293	Asus ROG Phone 9
294	Asus ROG Phone 9 Pro
295	Asus ROG Phone 8 / 8 Pro
296	Asus ROG Phone 8
297	Asus ROG Phone 8 Pro
298	Asus ROG Phone 7/7 Ultimate
299	Asus ROG Phone 7
300	Asus ROG Phone 7 Ultimate
301	Asus ROG Phone 6/6D Series
302	Asus ROG Phone 6
303	Asus ROG Phone 6 Pro
304	ROG Phone 6 Batman Edition
305	Asus ROG Phone 6D
306	Asus ROG Phone 6D Ultimate
307	Asus ROG Phone 5/5s Series
308	Asus ROG Phone 5
309	Asus ROG Phone 5 Ultimate
310	Asus ROG Phone 5 Pro
311	Asus ROG Phone 5s
312	Asus ROG Phone 5s Pro
313	Asus ROG Phone 3
314	Asus Zenpad 3S 10
315	Asus Zenpad Z10
316	Asus Zenpad Z8
317	Asus Zenpad 8.0
318	Asus Zenpad 10
319	Asus Zenpad 7.0
320	Asus Zenpad C 7.0
321	Bea-Fon M6
322	BlackBerry KEY2
323	BlackBerry KEY2 LE
324	BlackBerry KEYone
325	BlackBerry Motion
326	BlackBerry Priv
327	BlackBerry Passport
328	BlackBerry Classic
329	Blackview A200 Pro
330	Blackview A100
331	Blackview A95
332	Blackview A90
333	Blackview A80 / A80 Pro
334	Blackview A80
335	Blackview A80 Pro
336	Blackview A70
337	Blackview A60
338	Blackview A55
339	Blackview A55 Pro
340	Blackview A53 / A53 Pro
341	Blackview A53
342	Blackview A53 Pro
343	Blackview A52
344	Blackview BL9000 / BL9000 Pro
345	Blackview BL9000
346	Blackview BL9000 Pro
347	Blackview BL8000
348	Blackview BL7000
349	Blackview BV9800 Pro
350	Blackview BV9300
351	Blackview BV8200
352	Blackview BV8100
353	Blackview BV7300
354	Blackview BV4900 Pro
355	Blackview BV4800 / BV4800 Pro
356	Blackview BV4800
357	Blackview BV4800 Pro
358	Blackview N6000
359	Blackview N2000
360	Blackview N1000
361	Blackview Color 8
362	Blackview Color 6
363	Blackview Fort 100
364	Blackview Fort 5
365	Blackview Fort 2
366	Blackview Fort 1
367	Blackview Hero 10
368	Blackview Rock 5
369	Blackview Rock 3
370	Blackview Rock 2
371	Blackview Rock 2 Pro
372	Blackview Rock 1
373	Blackview Rock 1 Pro
374	Blackview Shark 9
375	Blackview Shark 8
376	Blackview Shark 6
377	Blackview Wave 10
378	Blackview Wave 9C
379	Blackview Wave 8
380	Blackview Wave 8C
381	Blackview Wave 7C
382	Blackview Wave 6C
383	Blackview Xplore 2
384	Blackview Xplore 1
385	Blackview Xplore 1 Pro
386	Blackview Xplore X1
387	Blackview Tab 90
388	Blackview Tab 80
389	Blackview Tab 70 WiFi
390	Blackview Tab 60
391	Blackview Tab 60 Pro
392	Blackview Tab 50 WiFi
393	Blackview Tab 18
394	Blackview Tab 16
395	Blackview Tab 16 Pro
396	Blackview Tab 15
397	Blackview Tab 15 Pro
398	Blackview Tab 13
399	Blackview Tab 13 Pro
400	Blackview Tab 12
401	Blackview Tab 12 Pro
402	Blackview Tab 11
403	Blackview Tab 11 WiFi
404	Blackview Tab 11 SE
405	Blackview Tab 10
406	Blackview Tab 10 WiFi
407	Blackview Tab 10 Pro
408	Blackview Tab 9
409	Blackview Tab 8 WiFi
410	Blackview Tab 7
411	Blackview Tab 7 Pro
412	Blackview Tab 7 WiFi
413	Blackview Tab 6
414	Blackview Tab 5
415	Blackview Active 12 Pro
416	Blackview Active 10 Pro
417	Blackview Active 8
418	Blackview Active 8 Pro
419	Blackview Active 6
420	Blackview MEGA 12
421	Blackview MEGA 8
422	Blackview MEGA 3
423	Blackview MEGA 2
424	Blackview MEGA 1
425	Blackview Link 8
426	Blackview Link 2
427	Blackview Zeno 10
428	Blackview Zeno 1
429	BOOX Go 10.3 (Gen II)
430	BOOX Go 6 (Gen II)
431	BOOX Note Air5 C
432	BQ Aquaris X Pro
433	BQ Aquaris M10
434	CAT S75
435	CAT S62 Pro
436	CAT S61
437	CAT S60
438	CAT S53
439	CAT S52
440	CAT S42
441	CAT S31
442	CAT S41
443	CAT B40
444	CMF Phone 2 Pro
445	CMF Phone 1
446	Crosscall Stellar-M6 / M6E
447	Crosscall Stellar-M6
448	Crosscall Stellar-M6E
449	Crosscall Stellar-X5
450	Crosscall Core-M6
451	Crosscall Core-S5
452	Crosscall Core-X5
453	Crosscall Core-T5
454	Cubot Note 50
455	Cubot Note 40
456	Cubot A30
457	Cubot A20
458	Cubot A10
459	Cubot A1
460	Cubot X90
461	Cubot X70
462	Cubot X30
463	Cubot KingKong 9
464	Cubot KingKong 8
465	Cubot King Kong 5
466	Cubot KingKong Ace 3
467	Cubot KingKong AX
468	Cubot KingKong X
469	Cubot KingKong ES
470	Cubot King Kong CS
471	Cubot Kingkong Mini 3
472	Cubot Max 5
473	Cubot Max 3
474	Cubot J20
475	Cubot P80
476	Cubot P50
477	Cubot Pocket 3
478	Cubot Tab 65
479	Cubot Tab 60
480	Cubot Tab 50
481	Cubot Tab 40
482	Cubot Tab 30
483	Cubot Tab 20
484	Cubot Tab 10
485	Cubot Tab KingKong
486	Cubot Tab KingKong Mini
487	Cubot Tab KingKong S
488	Doogee Note 59/59 Pro/59 Pro+
489	Doogee Note 59
490	Doogee Note 59 Pro
491	Doogee Note 59 Pro Plus
492	Doogee Note 58 / 58 Pro
493	Doogee Note 58
494	Doogee Note 58 Pro
495	Doogee Note 56/56 Plus/56 Pro
496	Doogee Note 56
497	Doogee Note 56 Plus
498	Doogee Note 56 Pro
499	Doogee N55/N55 Plus/N55 Pro
500	Doogee N55
501	Doogee N55 Plus
502	Doogee N55 Pro
503	Doogee N50
504	Doogee N50 Pro
505	Doogee S300 Plus / S300 Pro
506	Doogee S300 Plus
507	Doogee S300 Pro
508	Doogee S200 / S200 Pro
509	Doogee S200
510	Doogee S200 Pro
511	Doogee S200X
512	Doogee S118
513	Doogee S110
514	Doogee S100 Pro
515	Doogee S98
516	Doogee S98 Pro
517	Doogee S96 Pro
518	Doogee S61 / S61 Pro
519	Doogee S61
520	Doogee S61 Pro
521	Doogee S41 / S41 Pro
522	Doogee S41
523	Doogee S41 Pro
524	Doogee S40 Pro
525	Doogee S Cyber
526	Doogee S Punk
527	Doogee Smini
528	Doogee V31GT
529	Doogee V20
530	Doogee V20 PRO
531	Doogee V20S
532	Doogee V Max 2 / V Max 2 Pro
533	Doogee V Max 2
534	Doogee V Max 2 Pro
535	Doogee V Max
536	Doogee V Max Plus
537	Doogee V Max Play
538	Doogee V Max LR
539	Doogee X95
540	Doogee Blade 20 Series
541	Doogee Blade 10/10 Pro/Ultra
542	Doogee Blade 10
543	Doogee Blade 10 Pro
544	Doogee Blade 10 Ultra
545	Doogee Blade 10 Max
546	Doogee DK10
547	Doogee Fire 7
548	Doogee Fire 7 Pro
549	Doogee Fire 7 Ultra
550	Doogee Fire 6
551	Doogee Fire 6 Power
552	Doogee Fire 6 Max
553	Doogee Fire 5/5 Pro/5 Ultra
554	Doogee Fire 5
555	Doogee Fire 5 Pro
556	Doogee Fire 5 Ultra
557	Doogee Fire 3 Pro / 3 Ultra
558	Doogee Fire 3 Pro
559	Doogee Fire 3 Ultra
560	Doogee Tab A9
561	Doogee Tab A9 Plus
562	Doogee Tab A9 Pro
563	Doogee Tab A9 Pro Plus
564	Doogee Tab E3
565	Doogee Tab E3 Plus
566	Doogee Tab E3 Max
567	Doogee Tab E3 Pro
568	Doogee Tab G6
569	Doogee Tab G6 Plus
570	Doogee Tab G6 Max
571	Doogee R20
572	Doogee R10
573	Doogee R08
574	Doogee T40
575	Doogee T40 Pro
576	Doogee T30E
577	Doogee T30S
578	Doogee T30 Pro
579	Doogee T30 Ultra
580	Doogee T30 Max
581	Doogee T20
582	Doogee T20 mini
583	Doogee T20 mini Pro
584	Doogee T20 Ultra
585	Doogee T20S
586	Doogee T10
587	Doogee T10 Pro
588	Doogee T10 Plus
589	Doogee T10E
590	Doogee T10S
591	Doogee T10W
592	Doogee U13
593	Doogee U12
594	Doogee U11
595	Doogee U11 Pro
596	Doogee U10
597	Doogee U10 Pro
598	Doogee U9
599	Doogee V Pad 5G
600	Doro Aurora A30
601	Doro Aurora A20
602	Doro Aurora A10
603	Doro 8200
604	Doro 8100 / Doro 8100 Plus
605	Doro 8100
606	Doro 8100 Plus
607	Doro 8080
608	Doro 8050
609	Doro 8040
610	Doro 8035
611	Doro 1370
612	Doro 780X
613	Doro Tablet
614	Emporia SMART.8
615	Emporia SMART.7 Lite
616	Emporia SMART.7 mini
617	Emporia SMART.ME7
618	Emporia ME.6
619	Emporia SMART.6
620	Emporia SMART.6 Lite
621	Emporia SMART.5
622	Emporia SMART.5 mini
623	Emporia SMART.4
624	Emporia SMART.3mini
625	Emporia Simplicity
626	Emporia SUPEREASY
627	Emporia Euphoria V50
628	Emporia TABLET
629	Fairphone 6
630	Fairphone 5
631	Fairphone 4
632	Fairphone 3 / 3 Plus
633	Fairphone 3
634	Fairphone 3 Plus
635	Garmin Venu 3 (45mm)
636	Gigaset GS6 / GS6 Pro
637	Gigaset GS6
638	Gigaset GS6 Pro
639	Gigaset GS5
640	Gigaset GS5 Lite/GS5 Senior
641	Gigaset GS5 Lite
642	Gigaset GS5 Senior
643	Gigaset GS4
644	Gigaset GS290
645	Gigaset GS195
646	Gigaset GS190
647	Gigaset GS110
648	Gigaset GX50
649	Gigaset GX30
650	Gigaset GX6
651	Gigaset GX4
652	Gigaset GX290
653	Google Pixel 11
654	Google Pixel 11 Pro
655	Google Pixel 11 Pro XL
656	Google Pixel 11 Pro Fold
657	Google Pixel 10
658	Google Pixel 10 Pro
659	Google Pixel 10 Pro XL
660	Google Pixel 10 Pro Fold
661	Google Pixel 10a
662	Google Pixel 9
663	Google Pixel 9 Pro
664	Google Pixel 9 Pro XL
665	Google Pixel 9 Pro Fold
666	Google Pixel 9a
667	Google Pixel 8
668	Google Pixel 8 Pro
669	Google Pixel 8a
670	Google Pixel 7
671	Google Pixel 7 Pro
672	Google Pixel 7a
673	Google Pixel 6
674	Google Pixel 6 Pro
675	Google Pixel 6a
676	Google Pixel 5
677	Google Pixel 4
678	Google Pixel 4 XL
679	Google Pixel 4a
680	Google Pixel 4a 5G
681	Google Pixel 3
682	Google Pixel 3 XL
683	Google Pixel 3a
684	Google Pixel 3a XL
685	Google Pixel 2
686	Google Pixel 2 XL
687	Google Pixel
688	Google Pixel XL
689	Google Pixel Fold
690	Google Pixel Tablet
691	Google Pixel Watch 5 (41mm)
692	Google Pixel Watch 5 (45mm)
693	Google Pixel Watch 4 (41mm)
694	Google Pixel Watch 4 (45mm)
695	Google Pixel Watch 3 (41mm)
696	Google Pixel Watch 3 (45mm)
697	Google Pixel Watch 2
698	Google Pixel Watch 1
699	Hafury Meet
700	Hafury V1
701	Hafury GT20
702	HMD Arc
703	HMD Fusion
704	HMD Skyline
705	HMD Pulse / Pulse Plus
706	HMD Pulse
707	HMD Pulse Plus
708	HMD Pulse Pro
709	HMD Barbie Phone
710	Honor 600
711	Honor 600 Pro
712	Honor 600 Lite
713	Honor 400
714	Honor 400 Pro
715	Honor 400 Lite
716	Honor 400 Smart (4G/5G)
717	Honor 400 Smart (4G)
718	Honor 400 Smart 5G
719	Honor 200
720	Honor 200 Pro
721	Honor 200 Lite
722	Honor 200 Smart
723	Honor 90 Lite
724	Honor 90
725	Honor 70
726	Honor 50
727	Honor 50 Lite
728	Honor 20
729	Honor 20 Lite / 20e
730	Honor 20 Lite
731	Honor 20e
732	Honor 20 Pro
733	Honor 9X
734	Honor 9X Pro
735	Honor 9X Lite
736	Honor 8A (2019)
737	Honor 8S
738	Honor X8 (4G)
739	Honor X8 5G
740	Honor X8a
741	Honor X8d
742	Honor X7
743	Honor X6a
744	Honor X6b
745	Honor X5c / X5c Plus
746	Honor X5c
747	Honor X5c Plus
748	Honor Magic8 Pro
749	Honor Magic8 Lite
750	Honor Magic7 Pro
751	Honor Magic7 Lite
752	Honor Magic6 Pro
753	Honor Magic6 Lite
754	Honor Magic5 Pro
755	Honor Magic5 Lite
756	Honor Magic4 Pro
757	Honor Magic4 Lite 5G
758	Honor Magic V6
759	Honor Magic V5
760	Honor Magic V3
761	Honor Magic V2
762	Honor Magic Vs
763	Honor Play
764	Honor MagicPad 4
765	Honor MagicPad 2
766	Honor Pad V9
767	Honor Pad 10
768	Honor Pad 9
769	Honor Pad 8
770	Honor Pad X9
771	Honor Pad X9a
772	Honor Pad X9 Max
773	Honor Pad X8
774	Honor Pad X8a
775	HTC U24 Pro
776	HTC U23 Pro
777	HTC U12 Plus
778	HTC U12 Life
779	HTC U11
780	HTC U11 Life
781	HTC U11 Plus
782	HTC U Ultra
783	HTC Desire 22 Pro
784	HTC Desire 12 Plus
785	HTC Desire 626G
786	HTC 10
787	HTC One M9
788	HTC One M8 / M8s
789	HTC One M8
790	HTC One M8s
791	HTC One M7
792	Huawei Pura 90
793	Huawei Pura 80 Pro
794	Huawei Pura 80 Ultra
795	Huawei Pura 70
796	Huawei Pura 70 Pro
797	Huawei Pura 70 Ultra
798	Huawei P60 / P60 Pro
799	Huawei P60
800	Huawei P60 Pro
801	Huawei P50 Pro
802	Huawei P40
803	Huawei P40 Pro / P40 Pro Plus
804	Huawei P40 Pro
805	Huawei P40 Pro Plus
806	Huawei P40 Lite
807	Huawei P40 Lite E
808	Huawei P40 Lite 5G
809	Huawei P30
810	Huawei P30 Pro/P30 Pro New Ed
811	Huawei P30 Pro
812	Huawei P30 Pro New Edition
813	Huawei P30 Lite/P30 Lite New
814	Huawei P30 Lite
815	Huawei P30 Lite New Edition
816	Huawei P20
817	Huawei P20 Pro
818	Huawei P20 Lite
819	Huawei P20 Lite (2019)
820	Huawei P10
821	Huawei P10 Plus
822	Huawei P10 Lite
823	Huawei P9
824	Huawei P9 Plus
825	Huawei P9 Lite
826	Huawei P8
827	Huawei P8 Lite 2015
828	Huawei P8 Lite 2017
829	Huawei Ascend P7
830	Huawei P smart 2021
831	Huawei P smart 2020
832	Huawei P smart 2019
833	Huawei P smart (2017)
834	Huawei P smart Plus 2019
835	Huawei P smart Plus
836	Huawei P smart Pro
837	Huawei P smart Z
838	Huawei Mate X7
839	Huawei Mate X6
840	Huawei Mate 80 Pro
841	Huawei Mate 50 Pro
842	Huawei Mate 40 Pro
843	Huawei Mate 30 Pro
844	Huawei Mate 20
845	Huawei Mate 20 Pro
846	Huawei Mate 20 Lite
847	Huawei Mate 20 X
848	Huawei Mate 10 Pro
849	Huawei Mate 10 Lite
850	Huawei Mate 9
851	Huawei Mate 9 Pro
852	Huawei Mate 9 Lite
853	Huawei Mate 8
854	Huawei Ascend Mate 7
855	Huawei nova 14 Pro
856	Huawei nova 13
857	Huawei nova 13 Pro
858	Huawei nova 12s
859	Huawei nova 12i
860	Huawei nova 12 SE
861	Huawei nova 9 / Honor 50
862	Huawei nova 9
863	Huawei nova 9 SE
864	Huawei nova 8i/ Honor 50 Lite
865	Huawei nova 8i
866	Huawei nova 5T
867	Huawei nova 2
868	Huawei Nova
869	Huawei Nova Plus
870	Huawei Ascend Y530
871	Huawei Ascend Y300
872	Huawei G8 / GX8
873	Huawei G8
874	Huawei GX8
875	Huawei Y9 (2019)
876	Huawei Y7 / Y7 Prime (2019)
877	Huawei Y7 (2019)
878	Huawei Y7 Prime (2019)
879	Huawei Y7 / Y7 Prime (2017)
880	Huawei Y7 (2017)
881	Huawei Y7 Prime (2017)
882	Huawei Y6 (2019)
883	Huawei Y6 (2018)
884	Huawei Y6 (2017)
885	Huawei Y6 (2015)
886	Huawei Y6p
887	Huawei Y6s
888	Huawei Y5 (2019)
889	Huawei Y5p
890	Huawei Y625
891	Huawei Honor View 20
892	Huawei Honor View 10
893	Huawei Honor 10
894	Huawei Honor 10 Lite
895	Huawei Honor 9
896	Huawei Honor 9 Lite
897	Huawei Honor 8
898	Huawei Honor 8X
899	Huawei Honor 8X Max
900	Huawei Honor 7 / 7 Premium
901	Huawei Honor 7
902	Huawei Honor 7 Premium
903	Huawei Honor 7X
904	Honor6X / GR5 (2017)
905	Huawei Honor 6
906	Huawei Honor 6X
907	Huawei Honor 5X / GR5(2016)
908	Huawei Honor 5X
909	Huawei Honor 5C
910	Huawei GR5 (2017)
911	Huawei GR5 (2016)
912	Huawei MatePad Air (2026)
913	Huawei MatePad 12X (2025)
914	Huawei MatePad 12X (2024)
915	Huawei MatePad 11.5 S (2026)
916	Huawei MatePad 11.5 S (2025)
917	Huawei MatePad 11.5 S (2024)
918	Huawei MatePad 11.5 (2025)
919	Huawei MatePad 11.5 (2023)
920	Huawei MatePad 11 (2023)
921	Huawei MatePad 11 (2021)
922	Huawei MatePad 10.4 (2022)
923	Huawei MatePad 10.4 (2020)
924	Huawei MatePad Pro Max (2026)
925	Huawei MatePad Pro 13.2(2025)
926	Huawei MatePad Pro 13.2(2024)
927	Huawei MatePad Pro 12.2(2025)
928	Huawei MatePad Pro 12.2(2024)
929	Huawei MatePad Pro 12.6(2021)
930	Huawei MatePad Pro 11 (2022)
931	Huawei MatePad Pro 10.8(2021)
932	Huawei MatePad Pro (2019)
933	Huawei MatePad T 10
934	Huawei MatePad T 10s
935	Huawei MatePad T 8
936	Huawei MatePad SE 11
937	Huawei MatePad SE
938	Huawei MatePad Paper
939	Huawei MediaPad M5 (8.4)
940	Huawei MediaPad M5/Pro (10.8)
941	Huawei MediaPad M5 (10.8)
942	Huawei MediaPad M5 Pro (10.8)
943	Huawei MediaPad M5 Lite (8)
944	Huawei MediaPad M5 Lite (10)
945	Huawei MediaPad M3 Lite 10
946	Huawei MediaPad M3 8.4
947	Huawei MediaPad M3 Lite 8
948	Huawei MediaPad M2 10.0
949	Huawei MediaPad M2 8.0
950	Huawei MediaPad M2 7.0
951	Huawei MediaPad M1
952	Huawei MediaPad T5
953	Huawei MediaPad T3 10
954	Huawei MediaPad T3 8
955	Huawei MediaPad T3 7
956	Huawei MediaPad T2 10.0 Pro
957	Huawei MediaPad T2 7.0
958	Huawei MediaPad T2 7.0 Pro
959	Huawei MediaPad T1 10
960	Huawei MediaPad T1 8.0
961	Huawei MediaPad T1 7.0
962	Huawei Honor Pad 2
963	Huawei Watch GT 7 (41mm)
964	Huawei Watch GT 7 (46mm)
965	Huawei Watch GT 7 Pro
966	Huawei Watch GT6/GT6 Pro 46mm
967	Huawei Watch GT 6 (46mm)
968	Huawei Watch GT 6 Pro (46mm)
969	Huawei Watch GT5/GT5 Pro 46mm
970	Huawei Watch GT 5 (46mm)
971	Huawei Watch GT 5 Pro (46mm)
972	Huawei Watch GT 4 (46mm)
973	Huawei Watch GT3/GT3 Pro 46mm
974	Huawei Watch GT 3 (46mm)
975	Huawei Watch GT 3 Pro (46mm)
976	Huawei Watch D3
977	JIKOCXN C30
978	Kobo Elipsa 2E
979	Kobo Clara BW
980	Kobo Clara Colour
981	Kobo Clara 2E
982	Kobo Libra Colour
983	Kobo Libra 2
984	Kobo Sage
985	Kobo Nia
986	KXD A1
987	Leitzphone powered by Xiaomi
988	Lenovo ThinkTab X11 Gen 1
989	Lenovo Tab (10.1, 2025)
990	Lenovo Tab Plus Gen 2
991	Lenovo Tab Plus
992	Lenovo Tab One
993	Lenovo Tab K11 Gen 2
994	Lenovo Tab K11e
995	Lenovo Tab K11 Plus
996	Lenovo Tab K10
997	Lenovo Tab P12
998	Lenovo Tab P12 Pro
999	Lenovo Tab P11(Gen1)/P11 Plus
1000	Lenovo Tab P11 (2. Gen.)
1001	Lenovo Tab P11 (Gen 1)
1002	Lenovo Tab P11 Plus
1003	Lenovo Tab P11 Pro (2. Gen.)
1004	Lenovo Tab P11 Pro (1. Gen.)
1005	Lenovo Tab M11
1006	Lenovo Tab M10 5G (2023)
1007	Lenovo Tab M10 (3. Gen.)
1008	Lenovo Tab M10 HD (2. Gen.)
1009	Lenovo Tab M10 (1. Gen.)
1010	Lenovo Tab M10 Plus (3. Gen.)
1011	Lenovo Tab M10 Plus (2. Gen.)
1012	Lenovo Tab M9
1013	Lenovo Tab M8 (4. Gen.)
1014	Lenovo Tab M8 (3. Generation)
1015	Lenovo Tab M8 (2.Gen.) HD/FHD
1016	Lenovo Tab M8 (2. Gen.) HD
1017	Lenovo Tab M8 (2. Gen.) FHD
1018	Lenovo Tab M7 (3. Gen.)
1019	Lenovo Tab M7 (2. Gen.)
1020	Lenovo Yoga Tab (11.1, 2025)
1021	Lenovo Yoga Tab Plus (2025)
1022	Lenovo Yoga Smart Tab
1023	Lenovo Yoga Tab 3 Plus
1024	Lenovo Yoga Tab 3 10
1025	Lenovo Yoga Tab 3 Pro
1026	Lenovo Legion Tab Gen 5
1027	Lenovo Legion Tab Gen 3
1028	Lenovo Legion Tab
1029	Lenovo Idea Tab (11.0, 2025)
1030	Lenovo Idea Tab Plus (2025)
1031	Lenovo Idea Tab Pro Gen 2
1032	Lenovo Idea Tab Pro
1033	Lenovo Smart Paper
1034	Lenovo Tab Extreme
1035	Lenovo Tab 4 10 Plus
1036	Lenovo Tab 4 10
1037	Lenovo Tab 4 8 Plus
1038	Lenovo Tab 4 8
1039	Lenovo Tab3 8 Plus
1040	Lenovo Tab3 10
1041	Lenovo Tab3 8
1042	Lenovo Tab3 7
1043	Lenovo Tab 2 A10-70
1044	Lenovo Tab 2 A8-50
1045	Lenovo Tab 2 A7-30
1046	Lenovo Tab 2 A7-20
1047	Lenovo Tab 2 A7-10
1048	LG G8 ThinQ
1049	LG G8s ThinQ
1050	LG G8X ThinQ
1051	LG G7 ThinQ / G7 Fit
1052	LG G7 ThinQ
1053	LG G7 Fit
1054	LG G6
1055	LG G5
1056	LG G4
1057	LG G3
1058	LG G2
1059	LG G Flex 2
1060	LG K61
1061	LG K52
1062	LG K51S
1063	LG K50
1064	LG K50s
1065	LG K42 / K52
1066	LG K42
1067	LG K41S
1068	LG K40
1069	LG K40s
1070	LG K20
1071	LG K10 (2017)
1072	LG K10 (2016)
1073	LG K8 (2017)
1074	LG K4 (2017)
1075	LG K4 (2016)
1076	LG V40 ThinQ
1077	LG V30
1078	LG V30 Plus
1079	LG Q60
1080	LG Q6
1081	LG X Power 3
1082	LG X Power 2
1083	LG X Power
1084	LG X Screen
1085	LG Velvet / LG Velvet 5G
1086	LG Velvet
1087	LG Velvet 5G
1088	LG Wing
1089	LG Google Nexus 5
1090	LG Google Nexus 5X
1091	LG Stylus 2
1092	LG G Pad IV 8.0
1093	LG G Pad II 10.1
1094	LG G Pad 10.1
1095	LG G Pad 8.3
1096	LG G Pad 8.0
1097	Microsoft Lumia 950
1098	Microsoft Lumia 950 XL
1099	Microsoft Lumia 650
1100	Microsoft Lumia 640
1101	Microsoft Lumia 640 XL
1102	Microsoft Lumia 535
1103	Microsoft Lumia 435
1104	Surface Pro X
1105	Surface Pro (13", 2026)
1106	Surface Pro (12", 2025)
1107	Surface Pro 11
1108	Surface Pro 9
1109	Surface Pro 8
1110	Surface Pro 4/5/6/7
1111	Surface Pro 7
1112	Surface Pro 7 Plus
1113	Surface Pro 6
1114	Surface Pro 5
1115	Surface Pro 4
1116	Surface Go 4
1117	Surface Go 3
1118	Surface Go 2 (10.5)
1119	Surface Go (10inch)
1120	Motorola Signature
1121	Motorola Moto G200 5G
1122	Motorola Moto G100
1123	Motorola Moto G87
1124	Motorola Moto G86 5G
1125	Motorola Moto G86 Power 5G
1126	Motorola Moto G85 5G
1127	Motorola Moto G84 5G
1128	Motorola Moto G82 5G
1129	Motorola Moto G77
1130	Motorola Moto G75 5G
1131	Motorola Moto G73 5G
1132	Motorola Moto G72
1133	Motorola Moto G71 5G
1134	Motorola Moto G67/G77
1135	Motorola Moto G67
1136	Motorola Moto G62 5G
1137	Motorola Moto G60s
1138	Motorola Moto G57 Power
1139	Motorola Moto G56 5G
1140	Motorola Moto G55 5G
1141	Motorola Moto G54 5G
1142	Motorola Moto G53 5G
1143	Motorola Moto G52
1144	Motorola Moto G51 5G
1145	Motorola Moto G50
1146	Motorola Moto G47
1147	Motorola Moto G42
1148	Motorola Moto G41
1149	Motorola Moto G37 / G47
1150	Motorola Moto G37
1151	Motorola Moto G37 Power
1152	Motorola Moto G35 5G
1153	Motorola Moto G34 5G
1154	Motorola Moto G32
1155	Motorola Moto G31 / G41
1156	Motorola Moto G31
1157	Motorola Moto G30
1158	Motorola Moto G24
1159	Motorola Moto G23
1160	Motorola Moto G22
1161	Motorola Moto G20
1162	Motorola Moto G17
1163	Motorola Moto G15
1164	Motorola Moto G14
1165	Motorola Moto G13 / G23
1166	Motorola Moto G13
1167	Motorola Moto G10 / G30
1168	Motorola Moto G10
1169	Motorola Moto G06
1170	Motorola Moto G06 Power
1171	Motorola Moto G05
1172	Motorola Moto G04 / G04s
1173	Motorola Moto G04
1174	Motorola Moto G04s
1175	Motorola Moto G9 Play
1176	Motorola Moto G9 Plus
1177	Motorola Moto G9 Power
1178	Motorola Moto G8
1179	Motorola Moto G8 Plus
1180	Motorola Moto G8 Power
1181	Motorola Moto G8 Power Lite
1182	Motorola Moto G7
1183	Motorola Moto G7 Plus
1184	Motorola Moto G7 Play
1185	Motorola Moto G7 Power
1186	Motorola Moto G6
1187	Motorola Moto G6 Plus
1188	Motorola Moto G5
1189	Motorola Moto G5 Plus
1190	Motorola Moto G5s
1191	Motorola Moto G5s Plus
1192	Motorola Moto G4 / G4 Plus
1193	Motorola Moto G4
1194	Motorola Moto G4 Plus
1195	Motorola Moto G4 Play
1196	Motorola Moto G3
1197	Motorola Moto G2
1198	Motorola Moto G
1199	Motorola Moto G 5G
1200	Motorola Moto G 5G Plus
1201	Motorola Edge 70
1202	Motorola Edge 70 Pro
1203	Motorola Edge 70 Fusion
1204	Motorola Edge 70 Max
1205	Motorola Edge 70 Neo
1206	Motorola Edge 60
1207	Motorola Edge 60 Neo
1208	Motorola Edge 60 Pro
1209	Motorola Edge 60 Fusion
1210	Motorola Edge 50 Pro
1211	Motorola Edge 50 Ultra
1212	Motorola Edge 50 Fusion
1213	Motorola Edge 50 Neo
1214	Motorola Edge 40
1215	Motorola Edge 40 Pro
1216	Motorola Edge 40 Neo
1217	Motorola Edge 30
1218	Motorola Edge 30 Pro
1219	Motorola Edge 30 Ultra
1220	Motorola Edge 30 Neo
1221	Motorola Edge 30 Fusion
1222	Motorola Edge 20
1223	Motorola Edge 20 Pro
1224	Motorola Edge 20 Lite
1225	Motorola Razr Fold
1226	Motorola Razr 70
1227	Motorola Razr 70 Plus
1228	Motorola Razr 70 Ultra
1229	Motorola Razr 60
1230	Motorola Razr 60 Ultra
1231	Motorola Razr 50
1232	Motorola Razr 50 Ultra
1233	Motorola Razr 40 Ultra
1234	Motorola ThinkPhone 25
1235	Motorola ThinkPhone
1236	Motorola Defy (2021)
1237	Motorola Moto E30 / E40
1238	Motorola Moto E40
1239	Motorola Moto E32 / E32s
1240	Motorola Moto E32
1241	Motorola Moto E32s
1242	Motorola Moto E30
1243	Motorola Moto E22 / E22i
1244	Motorola Moto E22
1245	Motorola Moto E22i
1246	Motorola Moto E20
1247	Motorola Moto E15
1248	Motorola Moto E14
1249	Motorola Moto E13
1250	Motorola Moto E7
1251	Motorola Moto E7 Plus
1252	Moto E7 Power/E7i Power
1253	Motorola Moto E7 Power
1254	Motorola Moto E7i Power
1255	Motorola Moto E6 Plus
1256	Motorola Moto E6 Play
1257	Motorola Moto E6s (2020)/E6i
1258	Motorola Moto E6s (2020)
1259	Motorola Moto E6i
1260	Motorola Moto E5
1261	Motorola Moto E5 Plus
1262	Motorola Moto E4
1263	Motorola Moto E4 Plus
1264	Motorola Moto Z3 / Z3 Play
1265	Motorola Moto Z3
1266	Motorola Moto Z3 Play
1267	Motorola Moto Z2 Play
1268	Motorola Moto Z
1269	Motorola Moto C
1270	Motorola Moto C Plus
1271	Motorola Moto X4
1272	Motorola One / P30 Play
1273	Motorola One
1274	Motorola P30 Play
1275	Motorola One Vision
1276	Motorola One Zoom
1277	Motorola One Action
1278	Motorola One Macro
1279	Motorola One Hyper
1280	Murena One
1281	Nokia G60 5G
1282	Nokia G50
1283	Nokia G42 5G
1284	Nokia G22
1285	Nokia G10/G20
1286	Nokia G11/G21
1287	Nokia G21
1288	Nokia G20
1289	Nokia G11
1290	Nokia G11 Plus
1291	Nokia G10
1292	Nokia X30 5G
1293	Nokia X10/X20
1294	Nokia X20
1295	Nokia X10
1296	Nokia XR21
1297	Nokia XR20
1298	Nokia C32
1299	Nokia C22
1300	Nokia 9 PureView
1301	Nokia 8.3 5G
1302	Nokia 8.1
1303	Nokia 8
1304	Nokia 8 Sirocco
1305	Nokia 7.2
1306	Nokia 7.1
1307	Nokia 7 Plus
1308	Nokia 6.2 / Nokia 7.2
1309	Nokia 6.2
1310	Nokia 6.1
1311	Nokia 6.1 Plus
1312	Nokia 6
1313	Nokia 5.4
1314	Nokia 5.3
1315	Nokia 5.1
1316	Nokia 5.1 Plus
1317	Nokia 5
1318	Nokia 4.2
1319	Nokia 3.4
1320	Nokia 3.2
1321	Nokia 3.1
1322	Nokia 3.1 Plus
1323	Nokia 3
1324	Nokia 2.2
1325	Nokia 2.1
1326	Nokia 2
1327	Nokia 1.4
1328	Nokia 1
1329	Nokia 1 Plus
1330	Nokia Lumia 630 / 635
1331	Nokia Lumia 635
1332	Nokia Lumia 630
1333	Nokia Lumia 520/525
1334	Nokia Lumia 525
1335	Nokia Lumia 520
1336	Nokia 8210 4G
1337	Nokia 8110 4G
1338	Nokia 6310 (2021)
1339	Nokia 5710 XA
1340	Nokia 5310 (2020)
1341	Nokia 3310 4G
1342	Nokia 3310 (2017)
1343	Nokia 3210 (2024)
1344	Nokia 2660 Flip
1345	Nokia 800 Tough
1346	Nokia 515
1347	Nokia 301
1348	Nokia 235 4G (2024)
1349	Nokia 230
1350	Nokia 225 (2024)
1351	Nokia 225 (2014)
1352	Nokia 216
1353	Nokia 150 (2017)
1354	Nokia 130 (2017)
1355	Nokia 110 (2019)
1356	Nokia 105 (2019)
1357	Nokia Asha 300
1358	Nokia C2-01
1359	Nokia C5-00
1360	Nokia X3-02
1361	Nokia N1
1362	Nokia T21
1363	Nokia T20
1364	Nokia T10
1365	Nothing Phone (4a)
1366	Nothing Phone (4a) Pro
1367	Nothing Phone (4b)
1368	Nothing Phone (3)
1369	Nothing Phone (3a)
1370	Nothing Phone (3a) Pro
1371	Nothing Phone (3a) Lite
1372	Nothing Phone (2)
1373	Nothing Phone (2a)
1374	Nothing Phone (2a) Plus
1375	Nothing Phone (1)
1376	nubia RedMagic 11 Pro/11 Pro+
1377	nubia RedMagic 11 Pro
1378	nubia RedMagic 11 Pro Plus
1379	nubia RedMagic 11 Air
1380	nubia RedMagic 10 Pro/10 Pro+
1381	nubia RedMagic 10 Pro
1382	nubia RedMagic 10 Pro Plus
1383	nubia RedMagic 10 Air
1384	nubia RedMagic 9 Pro
1385	nubia RedMagic 8 Pro / 8S Pro
1386	nubia RedMagic 8 Pro
1387	nubia RedMagic 8S Pro
1388	nubia Red Magic 5G
1389	nubia Z80 Ultra
1390	nubia Z70 Ultra
1391	nubia Z70S Ultra
1392	nubia Z60 Ultra
1393	nubia Z60S Pro
1394	nubia Z50
1395	nubia Z50 Ultra
1396	nubia Z50S Pro
1397	nubia Air
1398	nubia Focus 2 5G
1399	nubia Focus 2 Ultra 5G
1400	nubia Focus 5G
1401	nubia Focus Pro 5G
1402	nubia Neo 3 GT 5G
1403	nubia Neo 2 5G
1404	nubia Music
1405	nubia Flip 2 5G
1406	nubia Flip 5G
1407	nubia Pad Pro
1408	nubia RedMagic Astra 2
1409	nubia RedMagic Astra
1410	nubia RedMagic Nova
1411	Olympia Neo
1412	Olympia Trek
1413	OnePlus 15
1414	OnePlus 15R
1415	OnePlus 13
1416	OnePlus 13R
1417	OnePlus 12
1418	OnePlus 12R
1419	OnePlus 11
1420	OnePlus 10 Pro
1421	OnePlus 10T
1422	OnePlus 9
1423	OnePlus 9 Pro
1424	OnePlus 8
1425	OnePlus 8 Pro
1426	OnePlus 8T
1427	OnePlus 7
1428	OnePlus 7 Pro
1429	OnePlus 7T
1430	OnePlus 6
1431	OnePlus 6T
1432	OnePlus 5
1433	OnePlus 5T
1434	OnePlus 3
1435	OnePlus 3T
1436	OnePlus 2
1437	OnePlus Nord 6
1438	OnePlus Nord 5
1439	OnePlus Nord 4
1440	OnePlus Nord 3 5G
1441	OnePlus Nord 2 5G
1442	OnePlus Nord 2T
1443	OnePlus Nord
1444	OnePlus Nord CE 6
1445	OnePlus Nord CE 6 Lite
1446	OnePlus Nord CE 5
1447	OnePlus Nord CE 4 Lite 5G
1448	OnePlus Nord CE 2 5G
1449	OnePlus Nord CE 2 Lite 5G
1450	OnePlus Nord CE 5G
1451	OnePlus Nord N100
1452	OnePlus Nord N10 5G
1453	OnePlus Open
1454	OnePlus Pad 3
1455	OnePlus Pad 2
1456	OnePlus Pad 2 Pro
1457	OnePlus Pad
1458	OnePlus Pad Go 2
1459	OnePlus Pad Go
1460	OnePlus Pad Lite
1461	Oppo Find X9
1462	Oppo Find X9 Pro
1463	Oppo Find X9 Ultra
1464	Oppo Find X9s
1465	Oppo Find X8
1466	Oppo Find X8 Pro
1467	Oppo Find X5
1468	Oppo Find X5 Pro
1469	Oppo Find X5 Lite
1470	Oppo Find X3 Pro
1471	Oppo Find X3 Neo
1472	Oppo Find X3 Lite
1473	Oppo Find X2 Pro
1474	Oppo Find X2 Neo
1475	Oppo Find X2 Lite
1476	Oppo Reno16 5G
1477	Oppo Reno16 Pro 5G
1478	Oppo Reno16 F 5G/Reno16 FS 5G
1479	Oppo Reno16 F 5G
1480	Oppo Reno16 FS 5G
1481	Oppo Reno15 5G
1482	Oppo Reno15 Pro 5G
1483	Oppo Reno15 F 5G/Reno15 FS 5G
1484	Oppo Reno15 F 5G
1485	Oppo Reno15 FS 5G
1486	Oppo Reno14 5G
1487	Oppo Reno14 F 5G/Reno14 FS 5G
1488	Oppo Reno14 F 5G
1489	Oppo Reno14 FS 5G
1490	Oppo Reno12 Pro 5G
1491	Oppo Reno10 5G
1492	Oppo Reno10 Pro 5G
1493	Oppo Reno8 Lite 5G
1494	Oppo Reno7 (4G)
1495	Oppo Reno6 5G
1496	Oppo Reno4 5G
1497	Oppo Reno4 Pro 5G
1498	Oppo Reno4 Z 5G
1499	Oppo Reno2
1500	Oppo Reno2 Z
1501	Oppo Reno 5G
1502	Oppo A76 / A96
1503	Oppo A96
1504	Oppo A94 5G
1505	Oppo A91
1506	Oppo A77 5G
1507	Oppo A76
1508	Oppo A54 5G / A74 5G
1509	Oppo A74 5G
1510	Oppo A74 (4G)
1511	Oppo A73 5G
1512	Oppo A52 / A72
1513	Oppo A72
1514	Oppo A54 5G
1515	Oppo A53s
1516	Oppo A52
1517	Oppo A16 / A16s
1518	Oppo A16
1519	Oppo A16s
1520	Oppo A15
1521	Oppo A6 Pro 5G
1522	Oppo A5
1523	Oppo A5 Pro (4G/5G)
1524	Oppo A5 Pro (4G)
1525	Oppo A5 Pro 5G
1526	Oppo Pad 5
1527	Oppo Pad 2
1528	Oppo Pad
1529	Oppo Pad Air 2
1530	Oppo Pad Air
1531	OSCAL C80
1532	OSCAL C70
1533	OSCAL C30 / C30 Pro
1534	OSCAL C30
1535	OSCAL C30 Pro
1536	OSCAL S70 / S70 Pro
1537	OSCAL S70
1538	OSCAL S70 Pro
1539	OSCAL Pilot 6
1540	OSCAL Pilot 5
1541	OSCAL Pilot 3
1542	OSCAL Pilot 2
1543	OSCAL Pilot 1
1544	OSCAL Marine 3
1545	OSCAL Marine 2
1546	OSCAL Marine 1
1547	OSCAL Tank 1
1548	OSCAL Tiger 13
1549	OSCAL Tiger 12
1550	OSCAL Tiger 10
1551	OSCAL Tiger 8
1552	OSCAL Modern 8
1553	OSCAL FLAT 3C
1554	OSCAL FLAT 2
1555	OSCAL FLAT 2C
1556	OSCAL FLAT 1C
1557	OSCAL Pad 200
1558	OSCAL Pad 100
1559	OSCAL Pad 90 Pro
1560	OSCAL Pad 90
1561	OSCAL Pad 80 WiFi
1562	OSCAL Pad 70
1563	OSCAL Pad 60
1564	OSCAL Pad 50 WiFi
1565	OSCAL Pad 30 WiFi
1566	OSCAL Pad 18
1567	OSCAL Pad 16
1568	OSCAL Pad 15
1569	OSCAL Pad 13
1570	OSCAL Pad 10
1571	OSCAL Pad 7
1572	OSCAL Pad 5
1573	OSCAL Elite 1
1574	OSCAL Spider 10
1575	OSCAL Spider 8
1576	Oukitel WP500
1577	Oukitel WP500 Ultra
1578	Oukitel WP300
1579	Oukitel WP210
1580	Oukitel WP200 / WP200 Pro
1581	Oukitel WP200
1582	Oukitel WP200 Pro
1583	Oukitel WP100 / WP100 Titan
1584	Oukitel WP100
1585	Oukitel WP100 Titan
1586	Oukitel WP62
1587	Oukitel WP61 5G / Ultra / Ti
1588	Oukitel WP61 5G
1589	Oukitel WP61 Ultra
1590	Oukitel WP61 Ti
1591	Oukitel WP60
1592	Oukitel WP58 / WP58 Pro
1593	Oukitel WP58
1594	Oukitel WP58 Pro
1595	Oukitel WP56
1596	Oukitel WP55 / Pro / Ultra
1597	Oukitel WP55
1598	Oukitel WP55 Pro
1599	Oukitel WP55 Ultra
1600	Oukitel WP53 / Pro / S
1601	Oukitel WP53
1602	Oukitel WP53 Pro
1603	Oukitel WP53 S
1604	Oukitel WP52
1605	Oukitel WP50
1606	Oukitel WP39
1607	Oukitel WP38
1608	Oukitel WP36
1609	Oukitel WP35
1610	Oukitel WP33 Pro
1611	Oukitel WP32
1612	Oukitel WP30 Pro
1613	Oukitel WP28
1614	Oukitel WP27
1615	Oukitel WP26
1616	Oukitel WP23
1617	Oukitel WP20 / WP20 Pro
1618	Oukitel WP20
1619	Oukitel WP20 Pro
1620	Oukitel WP6
1621	Oukitel WP5
1622	Oukitel WP5 Pro
1623	Oukitel C69
1624	Oukitel C68
1625	Oukitel C68 Plus
1626	Oukitel C66
1627	Oukitel C62/C62 Pro/C62 GT
1628	Oukitel C62
1629	Oukitel C62 Pro
1630	Oukitel C62 GT
1631	Oukitel C61/C61 Pro/C61 GT
1632	Oukitel C61
1633	Oukitel C61 Pro
1634	Oukitel C61 GT
1635	Oukitel C58 / C58 Pro
1636	Oukitel C58
1637	Oukitel C58 Pro
1638	Oukitel C57S / C57 Pro
1639	Oukitel C57S
1640	Oukitel C57 Pro
1641	Oukitel C53
1642	Oukitel C51
1643	Oukitel C50
1644	Oukitel C38
1645	Oukitel C37
1646	Oukitel C35 / C36
1647	Oukitel C36
1648	Oukitel C35
1649	Oukitel C33
1650	Oukitel C32
1651	Oukitel C26
1652	Oukitel C17
1653	Oukitel C7
1654	Oukitel C6
1655	Oukitel C5 (2025)
1656	Oukitel C3 (2025)
1657	Oukitel C2 (2025)
1658	Oukitel C1/C1 Plus/C1 Pro
1659	Oukitel C1
1660	Oukitel C1 Plus
1661	Oukitel C1 Pro
1662	Oukitel G7
1663	Oukitel G5
1664	Oukitel G3
1665	Oukitel G2
1666	Oukitel G1
1667	Oukitel K16
1668	Oukitel P1
1669	Oukitel OT12
1670	Oukitel OT11
1671	Oukitel OT8
1672	Oukitel OT5
1673	Oukitel OT5S
1674	Oukitel OKT3
1675	Oukitel RT10
1676	Oukitel RT8
1677	Oukitel RT7
1678	Oukitel RT6
1679	Oukitel RT5
1680	Oukitel RT3
1681	Oukitel RT2
1682	Oukitel RT1
1683	PEAQ PET 101-H232E-13
1684	PEAQ PET 1008-F464E
1685	PEAQ PET 10181-F464E 
1686	PEAQ PET 10980-F628E
1687	PocketBook Era
1688	PocketBook Era Lite
1689	PocketBook Era Color
1690	PocketBook InkPad One
1691	PocketBook InkPad 4
1692	PocketBook InkPad Color 3
1693	PocketBook Touch HD 3
1694	PocketBook Touch Lux 5
1695	PocketBook Verse
1696	PocketBook Verse Lite
1697	PocketBook Verse Pro
1698	PocketBook Verse Pro Color
1699	Realme 16 5G
1700	Realme 16 Pro
1701	Realme 16 Pro Plus
1702	Realme 15 5G
1703	Realme 15 Pro 5G
1704	Realme 14 Pro 5G
1705	Realme 14 Pro Plus 5G
1706	Realme 14x 5G
1707	Realme 14T 5G
1708	Realme 13 Pro 5G
1709	Realme 12 (4G)
1710	Realme 12 5G
1711	Realme 12 Plus 5G
1712	Realme 12 Pro/12 Pro Plus 5G
1713	Realme 12 Pro 5G
1714	Realme 12 Pro Plus 5G
1715	Realme 12x 5G
1716	Realme 9 Pro
1717	Realme 9 Pro Plus
1718	Realme 9i
1719	Realme 8 / 8 Pro
1720	Realme 8
1721	Realme 8 Pro
1722	Realme 8 5G
1723	Realme 8i
1724	Realme 7
1725	Realme 7 Pro
1726	Realme 7 5G
1727	Realme 6
1728	Realme 6 Pro
1729	Realme C71
1730	Realme C67 (4G)
1731	Realme C65 (4G)
1732	Realme C51
1733	Realme C35
1734	Realme C25Y
1735	Realme C21
1736	Realme C11 (2021)
1737	Realme GT 8 Pro
1738	Realme GT 7
1739	Realme GT 7T
1740	Realme GT 7 Pro
1741	Realme GT 6
1742	Realme GT 6T
1743	Realme GT2
1744	Realme GT2 Pro
1745	Realme GT 5G
1746	Realme GT Neo 3
1747	Realme GT Neo 3T
1748	Realme GT Neo 2
1749	Realme Narzo 50 (4G)
1750	Realme Narzo 50A Prime / C35
1751	Realme Narzo 50A Prime
1752	Realme P4 5G
1753	Realme P4 Pro 5G
1754	Realme P3
1755	Realme P3 Ultra
1756	Realme X50 Pro
1757	Realme Note 60
1758	Realme Note 50
1759	Realme Pad 2
1760	Realme Pad
1761	Realme Pad Mini
1762	Realme Pad X
1763	rephone
1764	RugOne Xever 8
1765	RugOne Xever 7 / 7 Pro
1766	RugOne Xever 7
1767	RugOne Xever 7 Pro
1768	Samsung Galaxy S26
1769	Samsung Galaxy S26 Plus
1770	Samsung Galaxy S26 Ultra
1771	Samsung Galaxy S26 FE
1772	Samsung Galaxy S25
1773	Samsung Galaxy S25 Plus
1774	Samsung Galaxy S25 Ultra
1775	Samsung Galaxy S25 Edge
1776	Samsung Galaxy S25 FE
1777	Samsung Galaxy S24
1778	Samsung Galaxy S24 Plus
1779	Samsung Galaxy S24 Ultra
1780	Samsung Galaxy S24 FE
1781	Samsung Galaxy S23
1782	Samsung Galaxy S23 Plus
1783	Samsung Galaxy S23 Ultra
1784	Samsung Galaxy S23 FE
1785	Samsung Galaxy S22
1786	Samsung Galaxy S22 Plus
1787	Samsung Galaxy S22 Ultra
1788	Samsung Galaxy S21
1789	Samsung Galaxy S21 Plus
1790	Samsung Galaxy S21 Ultra
1791	Samsung Galaxy S21 FE 5G
1792	Samsung Galaxy S20 / S20 5G
1793	Samsung Galaxy S20
1794	Samsung Galaxy S20 5G
1795	Samsung Galaxy S20 Plus / 5G
1796	Samsung Galaxy S20 Plus
1797	Samsung Galaxy S20 Plus 5G
1798	Samsung Galaxy S20 Ultra / 5G
1799	Samsung Galaxy S20 Ultra
1800	Samsung Galaxy S20 Ultra 5G
1801	Samsung Galaxy S20 FE / FE 5G
1802	Samsung Galaxy S20 FE
1803	Samsung Galaxy S20 FE 5G
1804	Samsung Galaxy S10
1805	Samsung Galaxy S10e
1806	Samsung Galaxy S10 Plus
1807	Samsung Galaxy S10 5G
1808	Samsung Galaxy S10 Lite
1809	Samsung Galaxy S9
1810	Samsung Galaxy S9 Plus
1811	Samsung Galaxy S8
1812	Samsung Galaxy S8 Plus
1813	Samsung Galaxy S7
1814	Samsung Galaxy S7 Edge
1815	Samsung Galaxy S7 active
1816	Samsung Galaxy S6
1817	Samsung Galaxy S6 Edge
1818	Samsung Galaxy S6 Edge Plus
1819	Samsung Galaxy S5 / S5 Neo
1820	Samsung Galaxy S5
1821	Samsung Galaxy S5 Neo
1822	Samsung Galaxy S5 Mini
1823	Samsung Galaxy S4
1824	Samsung Galaxy S4 Mini
1825	Samsung Galaxy S4 active
1826	Samsung Galaxy S3 / S3 Neo
1827	Samsung Galaxy S3
1828	Samsung Galaxy S3 Neo
1829	Samsung Galaxy S3 Mini
1830	Samsung Galaxy S2 / S2 Plus
1831	Samsung Galaxy S2
1832	Samsung Galaxy S2 Plus
1833	Samsung Galaxy S Duos 2
1834	Samsung Galaxy S / S Plus
1835	Samsung Galaxy S
1836	Samsung Galaxy S Plus
1837	Samsung Galaxy A90 5G
1838	Samsung Galaxy A80
1839	Samsung Galaxy A72 / A72 5G
1840	Samsung Galaxy A72
1841	Samsung Galaxy A72 5G
1842	Samsung Galaxy A71
1843	Samsung Galaxy A70
1844	Samsung Galaxy A57 5G
1845	Samsung Galaxy A56 5G
1846	Samsung Galaxy A55 5G
1847	Samsung Galaxy A54 5G
1848	Samsung Galaxy A53 5G
1849	Samsung Galaxy A52 / A52s 5G
1850	Samsung Galaxy A52
1851	Samsung Galaxy A52 5G
1852	Samsung Galaxy A52s 5G
1853	Samsung Galaxy A51
1854	Samsung Galaxy A50 / A30s
1855	Samsung Galaxy A50
1856	Samsung Galaxy A42 5G
1857	Samsung Galaxy A41
1858	Samsung Galaxy A40
1859	Samsung Galaxy A37 5G
1860	Samsung Galaxy A36 5G
1861	Samsung Galaxy A35 5G
1862	Samsung Galaxy A34 5G
1863	Samsung Galaxy A33 5G
1864	Samsung Galaxy A32 5G
1865	Samsung Galaxy A32 (4G)
1866	Samsung Galaxy A31
1867	Samsung Galaxy A30s
1868	Samsung Galaxy A27 5G
1869	Samsung Galaxy A26 5G
1870	Samsung Galaxy A25 5G
1871	Samsung Galaxy A23 5G
1872	Samsung Galaxy A23 (4G)
1873	Samsung Galaxy A22 5G
1874	Samsung Galaxy A22 (4G)
1875	Samsung Galaxy A21s
1876	Samsung Galaxy A20e
1877	Samsung Galaxy A20s
1878	Samsung Galaxy A17 (4G/5G)
1879	Samsung Galaxy A17 (4G)
1880	Samsung Galaxy A17 5G
1881	Samsung Galaxy A16 (4G/5G)
1882	Samsung Galaxy A16 (4G)
1883	Samsung Galaxy A16 5G
1884	Samsung Galaxy A15 (4G/5G)
1885	Samsung Galaxy A15 (4G)
1886	Samsung Galaxy A15 5G
1887	Samsung Galaxy A14 (4G/5G)
1888	Samsung Galaxy A14 (4G)
1889	Samsung Galaxy A14 5G
1890	Samsung Galaxy A13 5G
1891	Samsung Galaxy A13 (4G)
1892	Samsung Galaxy A12
1893	Samsung Galaxy A10
1894	Samsung Galaxy A10 / M10
1895	Samsung Galaxy A10
1896	Samsung Galaxy A07
1897	Samsung Galaxy A06 (4G/5G)
1898	Samsung Galaxy A06 (4G)
1899	Samsung Galaxy A06 5G
1900	Samsung Galaxy A05s
1901	Samsung Galaxy A04s
1902	Samsung Galaxy A03
1903	Samsung Galaxy A03s
1904	Samsung Galaxy A02s
1905	Samsung Galaxy A9 (2018)
1906	Samsung Galaxy A8 (2018)
1907	Samsung Galaxy A7 (2018)
1908	Samsung Galaxy A7 (2017)
1909	Samsung Galaxy A7 (2016)
1910	Samsung Galaxy A7 (2015)
1911	Samsung Galaxy A6 (2018)
1912	Samsung Galaxy A6 Plus (2018)
1913	Samsung Galaxy A5 (2017)
1914	Samsung Galaxy A5 (2016)
1915	Samsung Galaxy A5 (2015)
1916	Samsung Galaxy A3 (2017)
1917	Samsung Galaxy A3 (2016)
1918	Samsung Galaxy A3 (2015)
1919	Samsung Note 20 / Note20 5G
1920	Samsung Galaxy Note 20
1921	Samsung Galaxy Note 20 5G
1922	Samsung Galaxy Note 20 Ultra 5G
1923	Samsung Galaxy Note 10
1924	Samsung Note 10 Plus (4G/5G)
1925	Samsung Galaxy Note 10 Plus
1926	Samsung Galaxy Note 10 Plus 5G
1927	Samsung Galaxy Note 10 Lite
1928	Samsung Galaxy Note 9
1929	Samsung Galaxy Note 8
1930	Samsung Galaxy Note 5
1931	Samsung Galaxy Note 4
1932	Samsung Galaxy Note 3
1933	Samsung Galaxy Note 3 Neo
1934	Samsung Galaxy Note 2
1935	Samsung Galaxy XCover 7
1936	Samsung Galaxy XCover 7 Pro
1937	Samsung Galaxy Xcover 6 Pro
1938	Samsung Galaxy XCover 5
1939	Samsung Galaxy Xcover Pro
1940	Samsung Galaxy Xcover 4
1941	Samsung Galaxy Xcover 4s
1942	Samsung Galaxy Xcover 3
1943	Samsung Galaxy Z Fold 8 Ultra
1944	Samsung Galaxy Z Fold 8
1945	Samsung Galaxy Z Fold 7
1946	Samsung Galaxy Z Fold 6
1947	Samsung Galaxy Z Fold 5
1948	Samsung Galaxy Z Fold 4
1949	Samsung Galaxy Z Fold 2 5G
1950	Samsung Galaxy Fold
1951	Samsung Galaxy Z Flip 8
1952	Samsung Galaxy Z Flip 7
1953	Samsung Galaxy Z Flip 7 FE
1954	Samsung Galaxy Z Flip 6
1955	Samsung Galaxy Z Flip 5
1956	Samsung Galaxy Z Flip 4
1957	Samsung Galaxy Z Flip
1958	Samsung Galaxy M53 5G
1959	Samsung Galaxy M52 5G
1960	Samsung Galaxy M51
1961	Samsung Galaxy M33 5G
1962	Samsung Galaxy M32
1963	Samsung Galaxy M31
1964	Samsung Galaxy M31s
1965	Samsung Galaxy M30s
1966	Samsung Galaxy M23 5G
1967	Samsung Galaxy M22
1968	Samsung Galaxy M21
1969	Samsung Galaxy M20
1970	Samsung Galaxy M13
1971	Samsung Galaxy M12
1972	Samsung Galaxy M11
1973	Samsung Galaxy M10
1974	Samsung Galaxy J7 (2017)
1975	Samsung Galaxy J7 (2016)
1976	Samsung Galaxy J6 (2018)
1977	Samsung Galaxy J6 Plus
1978	Samsung Galaxy J5 (2017)
1979	Samsung Galaxy J5 (2016)
1980	Samsung Galaxy J5 (2015)
1981	Samsung Galaxy J4 (2018)
1982	Samsung Galaxy J4 Plus
1983	Samsung Galaxy J3 (2018)
1984	Samsung Galaxy J3 (2017)
1985	Samsung Galaxy J3 (2016)
1986	Samsung Galaxy J1 (2016)
1987	Samsung Galaxy J1 (2015)
1988	Samsung Galaxy Ace 2
1989	Samsung Galaxy Ace
1990	Samsung Galaxy Ace Style
1991	Samsung Galaxy Express 2
1992	Samsung Galaxy Grand Prime
1993	Samsung B2710
1994	Samsung Galaxy Tab S12 Ultra
1995	Samsung Galaxy Tab S12 Plus
1996	Samsung Galaxy Tab S11
1997	Samsung Galaxy Tab S11 Ultra
1998	Samsung Galaxy Tab S10 Plus
1999	Samsung Galaxy Tab S10 Ultra
2000	Samsung Galaxy Tab S10 Lite
2001	Samsung Galaxy Tab S10 FE
2002	Samsung Galaxy Tab S10 FE Plus
2003	Samsung Galaxy Tab S9
2004	Samsung Galaxy Tab S9 Plus
2005	Samsung Galaxy Tab S9 Ultra
2006	Samsung Galaxy Tab S9 FE
2007	Samsung Galaxy Tab S9 FE Plus
2008	Samsung Galaxy Tab S8
2009	Samsung Galaxy Tab S8
2010	Samsung Galaxy Tab S8 Plus
2011	Samsung Galaxy Tab S8 Plus
2012	Samsung Galaxy Tab S8 Ultra
2013	Samsung Galaxy Tab S7
2014	Samsung Galaxy Tab S7
2015	Samsung Galaxy Tab S7 Plus
2016	Samsung Galaxy Tab S7 Plus
2017	Samsung Galaxy Tab S7 FE
2018	Samsung Galaxy Tab S7 FE
2019	Galaxy Tab S7 FE / S7+ / S8+
2020	Samsung Galaxy Tab S7 / S8
2021	Samsung Galaxy Tab S5e / S6
2022	Samsung Galaxy Tab S6
2023	Samsung Galaxy Tab S6 Lite
2024	Samsung Galaxy Tab S5e
2025	Samsung Galaxy Tab S4
2026	Samsung Galaxy Tab S3
2027	Samsung Galaxy Tab S2 9.7
2028	Samsung Galaxy Tab S2 8.0
2029	Samsung Galaxy Tab S 10.5
2030	Samsung Galaxy Tab S 8.4
2031	Samsung Galaxy Tab A11
2032	Samsung Galaxy Tab A11 Plus
2033	Samsung Galaxy Tab A9
2034	Samsung Galaxy Tab A9 Plus
2035	Samsung Galaxy Tab A8 (2021)
2036	Samsung Galaxy Tab A7 2020/22
2037	Samsung Galaxy Tab A7 (2022)
2038	Samsung Galaxy Tab A7 (2020)
2039	Samsung Galaxy Tab A7 Lite
2040	Samsung Galaxy Tab A 10.5
2041	Samsung Tab A 10.1 (2019)
2042	Samsung Tab A 10.1 (2016)
2043	Samsung Galaxy Tab A 9.7
2044	Samsung Galaxy Tab A 8.0 2019
2045	Samsung Galaxy Tab A 8.0 2017
2046	Samsung Galaxy Tab A 8 (2015)
2047	Samsung Galaxy Tab A 7.0 2016
2048	Samsung Galaxy Tab Active5
2049	Samsung Galaxy Tab Active5 Pro
2050	Samsung Galaxy Tab Active 4 Pro
2051	Samsung Galaxy Tab Active3
2052	Samsung Galaxy Tab Active Pro
2053	Samsung Galaxy Tab Active 2
2054	Samsung Galaxy Tab 4 10.1
2055	Samsung Galaxy Tab 4 7.0
2056	Samsung Galaxy Tab 4 8.0
2057	Samsung Galaxy Tab 3 10.1
2058	Samsung Galaxy Tab 3 7.0
2059	Samsung Galaxy Tab 3 7.0 Lite
2060	Samsung Galaxy Tab 3 8.0
2061	Samsung Galaxy Tab 2 10.1
2062	Samsung Galaxy Tab 2 7.0
2063	Samsung Galaxy Tab E 9.6
2064	Samsung Galaxy Tab J
2065	Samsung Galaxy Tab Pro 10.1
2066	Samsung Galaxy Tab Pro 12.2
2067	Samsung Galaxy Tab Pro 8.4
2068	Samsung Galaxy Note 10.1
2069	Samsung Galaxy Watch Ultra 2
2070	Samsung Galaxy Watch Ultra
2071	Samsung Galaxy Watch9 (40mm)
2072	Samsung Galaxy Watch9 (44mm)
2073	Samsung Galaxy Watch8 (40mm)
2074	Samsung Galaxy Watch8 (44mm)
2075	Samsung Galaxy Watch8 Classic 46mm
2076	Samsung Galaxy Watch7 (40mm)
2077	Samsung Galaxy Watch7 (44mm)
2078	Samsung Galaxy Watch6 (40mm)
2079	Samsung Galaxy Watch6 (44mm)
2080	Samsung Galaxy Watch6 Classic 43mm
2081	Samsung Galaxy Watch6 Classic 47mm
2082	Samsung Galaxy Watch5 (40mm)
2083	Samsung Galaxy Watch5 (44mm)
2084	Samsung Galaxy Watch5 Pro
2085	Samsung Galaxy Watch4 (40mm)
2086	Samsung Galaxy Watch4 (44mm)
2087	Samsung Galaxy Watch4 Classic 42mm
2088	Samsung Galaxy Watch4 Classic 46mm
2089	Samsung Galaxy Watch3 (41mm)
2090	Samsung Galaxy Watch3 (45mm)
2091	Samsung Galaxy Watch 1 (42mm)
2092	Samsung Galaxy Watch 1 (46mm)
2093	Samsung Galaxy Watch Active2 40mm
2094	Samsung Galaxy Watch Active2 44mm
2095	Samsung Galaxy Watch Active
2096	Samsung Galaxy Buds 2 Pro/2/Live/Pro
2097	Samsung Galaxy Buds 2 Pro
2098	Samsung Galaxy Buds 2
2099	Samsung Galaxy Buds Live
2100	Samsung Galaxy Buds Pro
2101	SHIFTphone 8
2102	Shift 6mq
2103	Sonim XP Pro Thermal
2104	Sony Xperia 10 VIII
2105	Sony Xperia 10 VII
2106	Sony Xperia 10 VI
2107	Sony Xperia 10 V
2108	Sony Xperia 10 IV
2109	Sony Xperia 10 III
2110	Sony Xperia 10 II
2111	Sony Xperia 10 Plus
2112	Sony Xperia 10
2113	Sony Xperia 5 V
2114	Sony Xperia 5 IV
2115	Sony Xperia 5 III
2116	Sony Xperia 5 II
2117	Sony Xperia 5
2118	Sony Xperia 1 VIII
2119	Sony Xperia 1 VII
2120	Sony Xperia 1 VI
2121	Sony Xperia 1 V
2122	Sony Xperia 1 IV
2123	Sony Xperia 1 III
2124	Sony Xperia 1 II
2125	Sony Xperia 1
2126	Sony Xperia Pro-I
2127	Sony Xperia L4
2128	Sony Xperia L3
2129	Sony Xperia L2
2130	Sony Xperia XZ3
2131	Sony Xperia XZ2
2132	Sony Xperia XZ2 Compact
2133	Sony Xperia XZ1
2134	Sony Xperia XZ1 Compact
2135	Sony Xperia XZ
2136	Sony Xperia XZs
2137	Sony Xperia XZ Premium
2138	Sony Xperia X
2139	Sony Xperia X Compact
2140	Sony Xperia XA2
2141	Sony Xperia XA2 Plus
2142	Sony Xperia XA2 Ultra
2143	Sony Xperia XA1
2144	Sony Xperia XA1 Plus
2145	Sony Xperia XA1 Ultra
2146	Sony Xperia XA
2147	Sony Xperia Z5
2148	Sony Xperia Z5 Compact
2149	Sony Xperia Z5 Premium
2150	Sony Xperia Z3
2151	Sony Xperia Z3 Compact
2152	Sony Xperia Z3 Plus
2153	Sony Xperia Z2
2154	Sony Xperia Z1
2155	Sony Xperia Z1 Compact
2156	Sony Xperia Z
2157	Sony Xperia E5
2158	Sony Xperia E3
2159	Sony Xperia M5
2160	Sony Xperia M4 Aqua
2161	Sony Xperia Z4 Tablet
2162	Sony Xperia Z3 Tablet Compact
2163	Sony Xperia Z2 Tablet
2164	Swisstone BBM 320C
2165	TABWEE K10
2166	TABWEE T90
2167	TABWEE T80
2168	TABWEE T60
2169	TABWEE T60 Pro
2170	TABWEE T50
2171	TABWEE T20
2172	TABWEE W90
2173	TCL TAB 11
2174	TCL TAB 10 Gen 2
2175	TCL TAB 10 FHD 4G (Gen 1)
2176	TCL TAB 10L (Gen 2)
2177	TCL TAB 10L (Gen 1)
2178	TCL TAB 10s 5G
2179	TCL TAB 8
2180	TCL NXTPAPER 14
2181	TCL NXTPAPER 12 Pro
2182	TCL NXTPAPER 11
2183	TCL NXTPAPER 11 Plus
2184	TCL NXTPAPER 10s
2185	TECLAST M50
2186	TECLAST M50HD
2187	TECLAST M50 Pro
2188	TECLAST M50T
2189	TECLAST M40 Air
2190	TECLAST M40 Plus
2191	TECLAST M40 Pro
2192	TECLAST P85T
2193	TECLAST P80T
2194	TECLAST P50
2195	TECLAST P40HD
2196	TECLAST P40S
2197	TECLAST P30S
2198	TECLAST P26T
2199	TECLAST P25T
2200	TECLAST P20S
2201	TECLAST T70
2202	TECLAST T60
2203	TECLAST T60 Pro
2204	TECLAST T50
2205	TECLAST T50 Pro
2206	TECLAST T45HD
2207	TECLAST T40HD
2208	TECLAST T40S
2209	TECLAST T40 Air
2210	TECLAST T40 Pro
2211	Telekom T Phone 3
2212	Telekom T Phone 3 Pro
2213	Telekom T Phone 2
2214	Telekom T Phone 2 Pro
2215	Telekom T Phone
2216	Telekom T Phone Pro
2217	Telekom T Tablet 2
2218	Telekom T Tablet
2219	Tolino Shine Color
2220	Tolino Shine 5
2221	Tolino Shine 4
2222	Tolino Epos 3
2223	Tolino Vision Color
2224	Tolino Vision 6
2225	Tolino Page 2
2226	Ulefone Armor 34 / 34 Pro
2227	Ulefone Armor 34
2228	Ulefone Armor 34 Pro
2229	Ulefone Armor 33 / 33 Pro
2230	Ulefone Armor 33
2231	Ulefone Armor 33 Pro
2232	Ulefone Armor 30 / 30 Pro
2233	Ulefone Armor 30
2234	Ulefone Armor 30 Pro
2235	Ulefone Armor 29 Ultra
2236	Ulefone Armor 28 Pro/28 Ultra
2237	Ulefone Armor 28 Pro
2238	Ulefone Armor 28 Ultra
2239	Ulefone Armor 27 Pro/27T Pro
2240	Ulefone Armor 27 Pro
2241	Ulefone Armor 27T Pro
2242	Ulefone Armor 26 Ultra
2243	Ulefone Armor 25T / 25T Pro
2244	Ulefone Armor 25T
2245	Ulefone Armor 25T Pro
2246	Ulefone Armor 24
2247	Ulefone Armor 23 Ultra
2248	Ulefone Armor X32 / X32 Pro
2249	Ulefone Armor X32
2250	Ulefone Armor X32 Pro
2251	Ulefone Armor X31 / X31 Pro
2252	Ulefone Armor X31
2253	Ulefone Armor X31 Pro
2254	Ulefone Armor X16 / X16 Pro
2255	Ulefone Armor X16
2256	Ulefone Armor X16 Pro
2257	Ulefone Armor X13
2258	Ulefone Armor X12 Pro
2259	Ulefone Armor X10 / X10 Pro
2260	Ulefone Armor X10
2261	Ulefone Armor X10 Pro
2262	Ulefone Armor X8 / X8i
2263	Ulefone Armor X8
2264	Ulefone Armor X8i
2265	Ulefone Armor X6
2266	Ulefone Armor X5
2267	Ulefone Armor Mini 20/20T Pro
2268	Ulefone Armor Mini 20 Pro
2269	Ulefone Armor Mini 20T Pro
2270	Ulefone Armor Mini 5
2271	Ulefone Armor Mini 4
2272	Ulefone Power Armor 16S
2273	Ulefone Note 22
2274	Ulefone Note 21
2275	Ulefone Note 20 Pro
2276	Ulefone Note 19
2277	Ulefone Note 18 Ultra
2278	Ulefone Note 17 Pro
2279	Ulefone Note 16 Pro
2280	Ulefone Note 15
2281	Ulefone Note 14 / Note 14 Pro
2282	Ulefone Note 14
2283	Ulefone Note 14 Pro
2284	Ulefone RugKing 4 Pro
2285	Ulefone RugKing 3 Pro
2286	Ulefone RugKing 2 Pro
2287	Ulefone RugKing
2288	Ulefone RugKing Pad Pro
2289	Ulefone RugKing Pad 2 Pro
2290	Ulefone Armor Pad 5 Ultra
2291	Ulefone Armor Pad 5 Pro
2292	Ulefone Armor Pad 4 Ultra
2293	Ulefone Armor Pad 3 Pro
2294	Ulefone Armor Pad 2
2295	Ulefone Armor Pad
2296	Ulefone Armor Pad Pro
2297	Ulefone Armor Pad Lite
2298	Ulefone Tab A11 / Tab A11 Pro
2299	Ulefone Tab A11
2300	Ulefone Tab A11 Pro
2301	Ulefone Tab A10 / Tab A10 Pro
2302	Ulefone Tab A10
2303	Ulefone Tab A10 Pro
2304	Ulefone Tab A9 Pro
2305	Ulefone Tab A8
2306	Ulefone Tab A7
2307	Ulefone Tab W10
2308	Umidigi A15 Pro 5G
2309	Umidigi A15 / A15C
2310	Umidigi A15
2311	Umidigi A15C
2312	Umidigi C1
2313	Umidigi G100 / G100A
2314	Umidigi G100
2315	Umidigi G100A
2316	Umidigi G100 5G / G100 Pro
2317	Umidigi G100 5G
2318	Umidigi G100 Pro
2319	Umidigi G100x / G100x 5G
2320	Umidigi G100x
2321	Umidigi G100x 5G
2322	Umidigi G9 5G
2323	Umidigi G9A
2324	Umidigi G9C / G9T
2325	Umidigi G9C
2326	Umidigi G9T
2327	Umidigi G9x
2328	Umidigi G6 5G
2329	Umidigi X
2330	Umidigi Bison X20
2331	Umidigi Bison X10 / X10 Pro
2332	Umidigi Bison X10
2333	Umidigi Bison X10 Pro
2334	Umidigi Note 100/100 5G/100A
2335	Umidigi Note 100
2336	Umidigi Note 100 5G
2337	Umidigi Note 100A
2338	Umidigi Note 100x / 100x 5G
2339	Umidigi Note 100x
2340	Umidigi Note 100x 5G
2341	Umidigi Note 90
2342	Umidigi A15 Tab
2343	Umidigi A13 Tab
2344	Umidigi A11 Tab
2345	Umidigi G9 Tab
2346	Umidigi G7 Tab Pro
2347	Umidigi G5 Tab
2348	Umidigi G3 Tab
2349	Umidigi G3 Tab Ultra
2350	Umidigi G2 Tab
2351	Umidigi G1 Tab
2352	Umidigi G1 Tab Mini
2353	Umidigi Active T1
2354	vivo X Fold 6
2355	vivo X300
2356	vivo X300 Pro
2357	vivo X300 Ultra
2358	vivo X300 FE
2359	vivo X200
2360	vivo X200 Pro
2361	vivo X200 FE
2362	vivo X100 Pro
2363	vivo X90 Pro
2364	vivo X80 Pro
2365	vivo X60 Pro
2366	vivo X51 5G
2367	vivo V70 5G
2368	vivo V50 5G
2369	vivo V50 Lite (4G/5G)
2370	vivo V50 Lite (4G)
2371	vivo V50 Lite 5G
2372	vivo V40 5G
2373	vivo V40 Lite 5G
2374	vivo V40 SE (4G/5G)
2375	vivo V40 SE (4G)
2376	vivo V40 SE 5G
2377	vivo V29 Lite
2378	vivo V23 5G
2379	vivo V21 5G
2380	vivo Y76 5G
2381	vivo Y72 5G
2382	vivo Y70
2383	vivo Y36
2384	vivo Y33s
2385	vivo Y29s
2386	vivo Y21 / Y21s / Y33s
2387	vivo Y21
2388	vivo Y21s
2389	vivo Y20s
2390	Vodafone Tab Prime 7
2391	Volla Phone Plinius
2392	Volla Phone Quintus
2393	Volla Phone X23
2394	Volla Phone 22
2395	Volla Phone
2396	Volla Tablet
2397	Whitedeer G13
2398	Whitedeer A10 Pro
2399	Wiko Lenny
2400	Wiko Power U30
2401	Wiko Power U10 / U20
2402	Wiko Power U20
2403	Wiko Power U10
2404	Wiko View4
2405	Wiko View3 Lite
2406	Wiko View
2407	Wiko Y82
2408	Wiko Y61
2409	Xiaomi 17
2410	Xiaomi 17 Ultra
2411	Xiaomi 17T
2412	Xiaomi 17T Pro
2413	Xiaomi 15
2414	Xiaomi 15 Ultra
2415	Xiaomi 15T
2416	Xiaomi 15T Pro
2417	Xiaomi 14
2418	Xiaomi 14 Ultra
2419	Xiaomi 14T
2420	Xiaomi 14T Pro
2421	Xiaomi 13
2422	Xiaomi 13 Pro
2423	Xiaomi 13 Lite
2424	Xiaomi 13 Ultra
2425	Xiaomi 13T / 13T Pro
2426	Xiaomi 13T
2427	Xiaomi 13T Pro
2428	Xiaomi 12 / Xiaomi 12X
2429	Xiaomi 12
2430	Xiaomi 12X
2431	Xiaomi 12 Pro
2432	Xiaomi 12 Lite
2433	Xiaomi 12T / 12T Pro
2434	Xiaomi 12T
2435	Xiaomi 12T Pro
2436	Xiaomi Mi 11
2437	Xiaomi Mi 11i / Poco F3
2438	Xiaomi Mi 11i
2439	Xiaomi Mi 11 Lite/11 Lite 5G
2440	Xiaomi Mi 11 Lite
2441	Xiaomi Mi 11 Lite 5G
2442	Xiaomi Mi 11 Ultra
2443	Xiaomi 11T / 11T Pro
2444	Xiaomi 11T
2445	Xiaomi 11T Pro
2446	Xiaomi Mi 10
2447	Xiaomi Mi 10 Pro
2448	Xiaomi Mi 10 Lite 5G
2449	Xiaomi Mi 10T / Mi 10T Pro
2450	Xiaomi Mi 10T
2451	Xiaomi Mi 10T Pro
2452	Xiaomi Mi 10T Lite
2453	Xiaomi Mi 9 / Mi 9 Explorer
2454	Xiaomi Mi 9
2455	Xiaomi Mi 9 Explorer
2456	Xiaomi Mi 9 Pro
2457	Xiaomi Mi 9 SE
2458	Xiaomi Mi 9 Lite
2459	Xiaomi Mi 9T / Mi 9T Pro
2460	Xiaomi Mi 9T
2461	Xiaomi Mi 9T Pro
2462	Xiaomi Mi 8
2463	Redmi Note 15 (4G)
2464	Redmi Note 15 5G
2465	Redmi Note 15 Pro (4G)
2466	Redmi Note 15 Pro 5G
2467	Redmi Note 15 Pro+ 5G
2468	Redmi Note 14 (4G)
2469	Redmi Note 14 5G
2470	Redmi Note 14 Pro (4G)
2471	Redmi Note 14 Pro 5G
2472	Redmi Note 14 Pro+ 5G
2473	Redmi Note 13 (4G)
2474	Redmi Note 13 5G
2475	Redmi Note 13 Pro (4G)
2476	Redmi Note 13 Pro 5G
2477	Redmi Note 13 Pro+ 5G
2478	Redmi Note 12 (4G)
2479	Redmi Note 12 5G
2480	Redmi Note 12S
2481	Redmi Note 12 Pro (4G)
2482	Redmi Note 12 Pro 5G
2483	Redmi Note 12 Pro+ 5G
2484	Redmi Note 11/Note 11S
2485	Redmi Note 11
2486	Redmi Note 11S
2487	Redmi Note 11 Pro/11 Pro 5G
2488	Redmi Note 11 Pro
2489	Redmi Note 11 Pro 5G
2490	Redmi Note 11 Pro+ 5G
2491	Redmi Note 10/Note 10S
2492	Redmi Note 10
2493	Redmi Note 10S
2494	Redmi Note 10 Pro
2495	Redmi Note 10 5G/Poco M3 Pro
2496	Redmi Note 10 5G
2497	Redmi Note 9
2498	Redmi Note 9 Pro
2499	Redmi Note 9S
2500	Redmi Note 9T
2501	Redmi Note 8
2502	Redmi Note 8 Pro
2503	Redmi Note 8T
2504	Redmi Note 7/ Note 7 Pro / 7S
2505	Redmi Note 7
2506	Redmi Note 7 Pro
2507	Redmi Note 7S
2508	Redmi Note 5
2509	Redmi 17 (4G/5G)
2510	Redmi 17 (4G)
2511	Redmi 17 5G
2512	Redmi 15 (4G)
2513	Redmi 15 5G
2514	Redmi 15C (4G/5G)
2515	Redmi 15C (4G)
2516	Redmi 15C 5G
2517	Redmi 14C / Poco C75
2518	Redmi 14C
2519	Redmi 13
2520	Redmi 13C / Poco C65
2521	Redmi 13C
2522	Redmi 12
2523	Redmi 12C
2524	Redmi 10
2525	Redmi 10C
2526	Redmi 9
2527	Redmi 9A
2528	Redmi 9AT
2529	Redmi 9C
2530	Redmi 9T
2531	Redmi 8
2532	Redmi 8A
2533	Redmi 7
2534	Redmi 7A
2535	Redmi A7 Pro
2536	Redmi A5
2537	Redmi A3
2538	Redmi A2
2539	Redmi A1
2540	Xiaomi Mi A3
2541	Xiaomi Mi A2
2542	Xiaomi Mi A2 Lite
2543	Xiaomi Mi A1
2544	Xiaomi MIX Flip
2545	Xiaomi Mi Mix 2S
2546	Xiaomi Mi Mix 3
2547	Xiaomi Mi Note 10/Note 10 Pro
2548	Xiaomi Mi Note 10
2549	Xiaomi Mi Note 10 Pro
2550	Xiaomi Mi Note 10 Lite
2551	Poco F8 Pro
2552	Poco F8 Ultra
2553	Poco F7
2554	Poco F7 Pro
2555	Poco F7 Ultra
2556	Poco F6
2557	Poco F6 Pro
2558	Poco F5
2559	Poco F5 Pro
2560	Poco F4
2561	Poco F4 GT
2562	Poco F3
2563	Poco F2 Pro
2564	Pocophone F1
2565	Poco X8 Pro
2566	Poco X8 Pro Max
2567	Poco X7
2568	Poco X7 Pro
2569	Poco X6
2570	Poco X6 Pro
2571	Poco X5 5G
2572	Poco X5 Pro 5G
2573	Poco X4 Pro 5G
2574	Poco X4 GT
2575	Poco X3 NFC / X3 Pro
2576	Poco X3 NFC
2577	Poco X3 Pro
2578	Poco M8 5G
2579	Poco M8 Pro 5G
2580	Poco M7 (4G)
2581	Poco M7 Pro 5G
2582	Poco M6 (4G)
2583	Poco M6 Pro (4G)
2584	Poco M5
2585	Poco M5s
2586	Poco M4 5G
2587	Poco M4 Pro 5G
2588	Poco M4 Pro
2589	Poco M3
2590	Poco M3 Pro 5G
2591	Poco C85
2592	Poco C81 / C81 Pro
2593	Poco C81
2594	Poco C81 Pro
2595	Poco C75
2596	Poco C65
2597	Poco C40
2598	Xiaomi Pad Mini
2599	Xiaomi Pad 8
2600	Xiaomi Pad 8 Pro
2601	Xiaomi Pad 7
2602	Xiaomi Pad 7 Pro
2603	Xiaomi Pad 6
2604	Xiaomi Pad 6S Pro 12.4
2605	Xiaomi Pad 5
2606	Xiaomi Mi Pad 3
2607	Xiaomi Mi Pad 2
2608	Redmi Pad 2
2609	Redmi Pad 2 9.7
2610	Redmi Pad 2 Pro
2611	Redmi Pad
2612	Redmi Pad Pro
2613	Redmi Pad SE
2614	Redmi Pad SE 8.7
2615	Poco Pad C1
2616	Poco Pad M1
2617	Poco Pad X1
2618	Poco Pad
2619	Poco Watch
2620	Xiaomi Smart Band 8
2621	Redmi Watch 5 Active
2622	ZTE Blade A75
2623	ZTE Blade A73 (4G)
2624	ZTE Blade A73 5G
2625	ZTE Blade A72 5G
2626	ZTE Blade A71
2627	ZTE Blade A55
2628	ZTE Blade A54
2629	ZTE Blade A52
2630	ZTE Blade A51
2631	ZTE Blade A34
2632	ZTE Blade A32
2633	ZTE Blade A31
2634	ZTE Blade A31 Lite
2635	ZTE Blade A7 2020
2636	ZTE Blade A7 2019
2637	ZTE Blade A5 2020
2638	ZTE Blade A3 2020
2639	ZTE Blade V70
2640	ZTE Blade V70 Max
2641	ZTE Blade V70 Vita
2642	ZTE Blade V60 Vita
2643	ZTE Blade V50
2644	ZTE Blade V50 Vita
2645	ZTE Blade V50s
2646	ZTE Blade V40s
2647	ZTE Blade V30
2648	ZTE Blade V30 Vita
2649	ZTE Blade V2020
2650	ZTE Blade 10
2651	ZTE Blade 10 Vita
2652	ZTE Axon 40 Ultra
2653	ZTE Axon 11 / Axon 11 5G
2654	ZTE Axon 11
2655	ZTE Axon 11 5G
2656	ZTE Axon 10 Pro
2657	ZTE M9
2658	ZTE nubia Pad 3D
`;

let isEnabled = true;

// SETTINGS END, DO NOT EDIT THE CODE BELOW.

document.addEventListener('Searchanise.Loaded', function() {
    (function($) {

        if (!isEnabled || isEnabled === 'false') { return }

        let filterAttr = 'filter_metafield_3f0b03c8f85314eb30d1544ffab0be93';

        function parseImportIntoObject() {
            // trim any extra new line characters in the beginning and end of the user input
            filterImport = filterImport.replaceAll(/^\D+\n/g, '');
            filterImport = filterImport.replaceAll(/\D+\n$/g, '');
            
            let positionsArray = filterImport.replaceAll(/\t.+\n/g, ' ').trim().replaceAll('\\n', '').replaceAll('\\t', '').split(' ');
            
            let valuesArray = filterImport.split(/\n.+\t/);
            if (valuesArray[0] === '') {
                valuesArray.shift();
            }
            if (valuesArray[valuesArray.length - 1].includes('\n')) {
                valuesArray[valuesArray.length - 1] = valuesArray[valuesArray.length - 1].replace('\n', '');
            }

            let valuesPositionsObject = {};

            for (let i = 0; i < positionsArray.length; i++) {
                valuesPositionsObject[valuesArray[i]] = positionsArray[i];
            }
            
            return valuesPositionsObject;
        }

        function findAllOptionsInOrder(filterData, valuesPositionsObject) {
            console.log('findAllOptionsInOrder');
            console.log(filterData);
            let filterDataOptionsObject = {};
            for (let bucket of filterData.buckets) {
                filterDataOptionsObject[bucket.value] = bucket.count;
            }

            let availableImportValuesArray = [];
            let valuesNotFoundInImportArray = [];
            Object.keys(filterDataOptionsObject).forEach(function(item) {
                if (valuesPositionsObject[item]) {
                    availableImportValuesArray.push({'value': item, 'count': filterDataOptionsObject[item]})
                } else {
                    valuesNotFoundInImportArray.push({'value': item, 'count': filterDataOptionsObject[item]})
                }
            });
            
            let availableImportValuesArrayInOrder = [];
            
            for (let entry of Object.entries(valuesPositionsObject)) {
                for (let item of availableImportValuesArray) {
                    if (item.value == entry[0]) {
                        availableImportValuesArrayInOrder[entry[1]] = item;
                    }
                }
            }
            
            availableImportValuesArrayInOrder = availableImportValuesArrayInOrder.filter(function(item) {
                return item ? true : false; 
            })

            let allOptionsArray = [...availableImportValuesArrayInOrder, ...valuesNotFoundInImportArray];

            return allOptionsArray;
        }

        function findAppliedFilterOptions(params, valuesInOrder) {
            if (params && params.restrictBy && params.restrictBy[filterAttr]) {
                let appliedValuesList;
                if (params.restrictBy[filterAttr].includes('|')) {
                    appliedValuesList = params.restrictBy[filterAttr].split('|');
                } else if (params.restrictBy[filterAttr].includes(',')) {
                    appliedValuesList = params.restrictBy[filterAttr].split(',');
                } else {
                    appliedValuesList = params.restrictBy[filterAttr].split();
                }

                for (let option of valuesInOrder) {
                    if (appliedValuesList.includes(option.value)) {
                        option.selected = 'true';
                    }
                }
            }

            return valuesInOrder;
        }

        $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
            if (type == 'results' && data && data.facets) {
                let filterData;
                let filterIndex;

                data.facets.forEach(function(item, index) {
                    if (item.attribute == filterAttr) {
                        filterData = { ...item };
                        filterIndex = index;
                    }
                })

                if (!filterData) { return }

                let valuesPositionsObject = parseImportIntoObject();
                let valuesInOrder = findAllOptionsInOrder(filterData, valuesPositionsObject);
                let valuesWithSelected = findAppliedFilterOptions(params, valuesInOrder);

                data.facets[filterIndex].buckets = valuesWithSelected;
            }   
        });
    })(window.Searchanise.$);
});
}
snizeCustomFilterOptionsOrder();